import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { HiArrowRight } from 'react-icons/hi';
import { summitMalattieRareEvent } from '../data/summitMalattieRare';

const MalattieRare = () => {
  const diseases = [
    {
      id: 1,
      title: "Altri deficit congeniti dei fattori dela coagulazione",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Alterazioni DEL FIBRINOGENO</h3>
          <p>
            I difetti di FI o fibrinogeno sono un insieme di rari disordini ereditari della coagulazione causati da una carenza dello stesso o da un suo alterato funzionamento. Sono caratterizzati da quadri sintomatologici vari, che comprendono manifestazioni emorragiche ma anche trombotiche. Vengono distinte varie forme. L'afibrinogenemia, in cui si ha l'assenza completa della proteina con quadri emorragici gravi per cui è necessario eseguire terapia con concentrati di fibrinogeno, o in mancanza di tali prodotti, con plasma fresco congelato. In tale patologia si possono presentare anche dei fenomeni trombotici gravi. L'ipofibrinogenemia, caratterizzata da un deficit parziale del fibrinogeno con manifestazioni cliniche variabili e solitamente lievi. La disfibrinogenemia in cui vi è un aumento della quantità di fibrinogeno e riduzione della sua attività coagulante; le manifestazioni cliniche sono estremamente variabili e vanno dalla mancanza di sintomi, a problemi emorragici o trombotici.
          </p>

          <h3 className="text-lg font-bold text-primary">DEFICIT DEL FATTORE II</h3>
          <p>
            Il deficit di FII o protrombina è uno dei più rari disordini coagulativi ereditari. Agli esami della coagulazione si evidenzia un allungamento consensuale di PT e aPTT. La diagnosi definitiva si basa sul dosaggio del FII e la terapia consiste nell'uso di concentrati del complesso protrombinico. Si può presentare con sintomi emorragici gravi.
          </p>

          <h3 className="text-lg font-bold text-primary">DEFICIT DEL FATTORE V</h3>
          <p>
            La carenza di fattore V è un disordine emorragico ereditario la cui diagnosi si basa sull'allungamento consensuale di PT e aPTT e sul dosaggio del FV. I sintomi più comuni sono rappresentati da epistassi, ecchimosi, menorragia, sanguinamenti gastro intestinali e dopo interventi chirurgici. La terapia si basa sull'infusione di plasma fresco congelato.
          </p>

          <h3 className="text-lg font-bold text-primary">DEFICIT DEL FATTORE VII</h3>
          <p>
            La carenza di FVII è il più comune tra i difetti rari della coagulazione, con manifestazioni cliniche molto variabili, che comprendono sia sanguinamenti mucosi (epistassi, menometrorragia nella donna ecc.) che sanguinamenti a tipo emartri, ematomi profondi ed anche emorragia cerebrale se il deficit di FVII è grave. Il trattamento consiste nella terapia sostitutiva per via endovenosa di concentrati plasma-derivati o ricombinanti di FVII. In mancanza di tali prodotti può essere utilizzato il plasma fresco congelato.
          </p>

          <h3 className="text-lg font-bold text-primary">DEFICIT DEL FATTORE X</h3>
          <p>
            La carenza del FX si manifesta in maniera diversa a seconda che si tratti di un difetto di quantitativo o qualitativo. I sintomi emorragici possono essere gravi. Allo screening coagulativo di base si evidenzia un allungamento sia del PT che dell'aPTT; la diagnosi viene posta poi mediante dosaggio del fattore X la cui completa assenza è di fatto incompatibile con la vita. La terapia si basa sull'uso di concentrati del complesso protrombinico.
          </p>

          <h3 className="text-lg font-bold text-primary">DEFICIT DEL FATTORE XI</h3>
          <p>
            La carenza del FXI o emofilia C, è una coagulopatia in cui la sintomatologia emorragica molto spesso non dipende dai livelli circolanti del FXI. Infatti, ci possono essere pazienti con un deficit grave che sono asintomatici, e pazienti con un deficit lieve che presentano sintomi emorragici. Raramente i sanguinamenti si presentano in maniera spontanea, verificandosi perlopiù in seguito a traumi o interventi chirurgici. La terapia si basa sull'uso di plasma fresco congelato o del concentrato specifico di FXI; possono essere utilizzati anche antifibrinolitici in caso di flussi mestruali abbondanti e lunghi (menorragia) o interventi minori.
          </p>

          <h3 className="text-lg font-bold text-primary">DEFICIT DEL FATTORE XIII</h3>
          <p>
            La carenza del FXIII è un disordine congenito molto raro. La sintomatologia emorragica è spesso precoce e si può presentare nel neonato alla caduta del cordone ombelicale. In un 25-35% dei pazienti si verifica emorragia cerebrale, mentre le donne possono manifestare fenomeni di poliabortività. La diagnosi viene posta mediante dosaggio del FXIII. Il PT e l'aPTT sono normali. La terapia si basa sulla somministrazione del concentrato plasmaderivato o ricombinante del FXIII. Grazie alla lunga emivita del FXIII, è mandatorio, subito dopo la diagnosi di una carenza grave, iniziare una profilassi, con somministrazione del concentrato circa una volta al mese.
          </p>

          <h3 className="text-lg font-bold text-primary">DEFICIT COMBINATO DI FATTORE V E FATTORE VIII</h3>
          <p>
            I sintomi che caratterizzano questa coagulopatia combinata sono generalmente lievi e associati a un trauma o ad un intervento chirurgico. La terapia si basa sul trattamento combinato di plasma fresco congelato e il concentrato di FVIII o somministrazione di desmopressina. I pazienti vengono trattati solitamente al bisogno o in profilassi di interventi chirurgici/manovre invasive.
          </p>

          <h3 className="text-lg font-bold text-primary">Carenza congenita combinata dei fattori Vitamina K dipendenti (VKCFD)</h3>
          <p>
            È un raro difetto congenito, a trasmissione autosomica recessiva, causato da mutazioni nei geni che producono due proteine necessarie per una funzione coagulativa corretta ed efficace. Tale difetto consiste nella carenza combinata di FII, FVII, FIX, FX, così come di alcuni inibitori fisiologici della coagulazione quali la proteina (P)C, la PS. I sintomi emorragici variano in accordo con i livelli delle proteine procoagulanti, in relazione alla disponibilità della vitamina K. I pazienti affetti da tale patologia, presentano anche una serie di altri sintomi correlati al difetto di altre proteine, con anomalie dello sviluppo e dello scheletro. I pazienti presentano un incremento variabile del PT e dell'aPTT a seconda dei livelli circolanti di FII, FVII, FIX, FX.
          </p>

          <div className="mt-6 border-t pt-4">
            <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
            <p>
              I "deficit congeniti rari" della coagulazione sono delle coagulopatie estremamente rare e sono generalmente trasmessi con modalità autosomica recessiva. Nonostante siano considerati come gruppo di patologie, si differenziano notevolmente per i sintomi, presentazione e diagnosi di laboratorio. Includono: i difetti del fibrinogeno o fattore (FI), il deficit del fattore (F) II, del FV, del FVII, del FX, del FXI, del FXIII, il deficit combinato di FV + FVIII e il deficit congenito multiplo dei fattori vitamina K dipendenti
            </p>
          </div>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-4">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG020</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di Riferimento e Coordinamento Regionale per le Malattie Emorragiche (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27a, 1° piano.
            </p>
            <p className="mt-2">
              <strong>Referenti:</strong> Dott.ssa Cristina Santoro, Dott.ssa Erminia Baldacci, Dott. Antonio Chistolini
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita per adulti e bambini scrivere a:</strong>
            </p>
            <p className="text-accent mt-1">
              gruppogz@gmail.com
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="space-y-2 mt-2">
              <li>
                <a href="https://aiceonline.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Centri Emofilia (AICE)
                </a>
              </li>
              <li>
                <a href="https://fedemo.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Federazione delle Associazioni Emofilici (FedEmo)
                </a>
              </li>
              <li>
                <a href="https://www.fondazioneparacelso.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Fondazione Paracelso (associazione pazienti)
                </a>
              </li>
              <li>
                <a href="https://www.aelonlus.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Emofilici Lazio (AEL)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 2,
      title: "Amiloidosi primarie e familiari",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>L'amiloidosi sistemica è una patologia caratterizzata dall'accumulo di aggregati proteici anomali che formano depositi in diversi organi.</p>
          <p>L'amiloidosi primaria o primitiva è la forma sistemica più comune. Questa condizione è abitualmente la conseguenza di discrasie plasmacellulari o altre malattie linfoproliferative, ed è causata dall'accumulo di fibrille contenenti catene delle immunoglobuline derivate da plasmacellule monoclonali.</p>
          <p>Le amiloidosi primarie si distinguono in base alla natura biochimica delle proteine che formano le fibrille:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Amiloidosi AL, in cui il precursore delle proteine sono catene leggere delle immunoglobuline (Ig)</li>
            <li>Amiloidosi AH, forma più rara in cui il precursore delle proteine sono catene pesanti delle immunoglobuline (Ig).</li>
          </ul>
          <p>I depositi fibrillari possono depositarsi gradualmente a livello di numerosi tessuti e organi, quali la cute, i nervi, il cuore, il tratto gastrointestinale, i reni, il fegato, la milza e i vasi sanguigni già da diversi anni prima della presentazione clinica vera e propria.</p>
          <p>L'amiloidosi familiare è una rara patologia ereditaria dovuta a mutazioni genetiche di proteine del sangue che, formando fibrille amiloidi, colpiscono in particolare reni, nervi e cuore. Solitamente è causata dalla trasmissione di un gene mutante che codifica per una proteina incline al mal ripiegamento, più comunemente la transtiretina (TTR), prodotta dal fegato, inoltre sono coinvolte altre proteine quali l'apolipoproteina A-I, l'apolipoproteina A-II, il lisozima, il fibrinogeno, la gelsolina e la cistatina C.</p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>La sintomatologia è variabile da sintomi aspecifici come affaticamento, edema e perdita di peso a sintomi più specifici dipendenti dall'organo prevalentemente interessato e dalle dimensioni raggiunte dai depositi di amiloide. Ad esempio, la sindrome del tunnel carpale può precedere altre manifestazioni della malattia neurologica.</p>
          <p>Si deve sospettare un'amiloidosi quando il soggetto manifesta sintomi multiorgano senza causa evidente, in questi casi in prima istanza si può eseguire l'esame fisico per rilevare i segni clinici del coinvolgimento d'organo, successivamente bisognerà eseguire analisi del sangue e delle urine per riscontrare la proteina fibrillare coinvolta.</p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>La diagnosi di amiloidosi primaria può essere confermata definitivamente mediante biopsia del tessuto coinvolto ovvero, mediante dimostrazione della presenza di depositi fibrillari in un organo in seguito all'esame microscopico del campione di tessuto prelevato e processato con colorazione con rosso congo.</p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>Nell'amiloidosi primaria, l'obiettivo è quello di ridurre il livello di immunoglobuline circolanti ed eliminare le cellule anomale del midollo osseo. A tale scopo, il trattamento di scelta è rappresentato dalla chemioterapia e in casi selezionati il trapianto di cellule staminali.</p>
          <p>Per la forma familiare di amiloidosi da accumulo di transtiretina è possibile utilizzare:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Farmaci che hanno lo scopo di inibire il mal ripiegamento della transitetrina e la formazione di fibrille rallentando la progressione della malattia neurologica (stabilizzatori del tetramero: diflunisal e tafamidis).</li>
            <li>Farmaci che silenziano il gene TTR (Patisiran e inotersen) utilizzando RNA anti-senso o "RNA interference" per bloccare la traduzione del TTR in mRNA, ridurre i livelli sierici di transitetrina e migliorare gli esiti neurologici in circa il 50% dei pazienti.</li>
            <li>Trapianto di fegato, sede primaria di produzione della proteina mutante.</li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>La prognosi dipende dal tipo di amiloidosi, dagli apparati interessati e dalla tempestività diagnostica ed è peggiore per i pazienti con forma complicata da grave cardiomiopatia (sopravvivenza media inferiore ad 1 anno). I casi di amiloidosi familiare non trattati di solito presentano coinvolgimento cardiaco e neurologico terminale nell'arco di 5-15 anni.</p>
          <p>Le cause di morte più frequenti sono rappresentate da quadri di insufficienza cardiaca, renale e respiratoria, emorragie del tratto gastroenterico ed infezioni.</p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RCG130</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Dott.ssa Maria Teresa Petrucci, Centro di riferimento regionale per le Amiloidosi Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27a, 2° piano.
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="http://www.amiloidosi.it" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Società Italiana per l'Amiloidosi (SIA) – ONLUS
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 3,
      title: 'Anemia a cellule falciformi',
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            L'anemia a cellule falciformi o drepanocitosi (Sickle Cell Disease, SCD) è una malattia ereditaria, caratterizzata dalla produzione di una emoglobina (Hb) anomala (HbS). Rappresenta l'emoglobinopatia più diffusa. E' una malattia a trasmissione autosomica recessiva, che si manifesta, cioè, quando entrambi i geni che permettono la produzione delle catene beta dell'Hb sono alterati. Il nome della patologia deriva dal fatto che l'emoglobina, essendo la catena beta alterata, in particolari condizioni precipita nel globulo rosso (GR) alterandone la struttura, che, da disco biconcavo, assume una forma a falce. I GR falcemici perdono le normali caratteristiche di deformabilità e ostruiscono i piccoli vasi che irrorano organi e tessuti, causando crisi dolorose, danneggiando le cellule e determinando uno stato infiammatorio cronico. Inoltre, i GR a falce rimangono intrappolati e distrutti nella milza, con conseguente anemia e ittero.
          </p>
          <p>
            È estremamente diffusa nell'Africa sub-sahariana, nelle regioni tropicali, in India e Medio Oriente; in seguito, ai flussi migratori, negli anni si è diffusa a livello globale. La SCD, come altre anemie ereditarie, appartiene storicamente alle regioni con alto rischio di Malaria, poiché i GR dei portatori sani resistono maggiormente all'infezione. In Italia è presente soprattutto in Sicilia e Sardegna. L'incidenza globale è di circa 300.000 nuovi nati ogni anno.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>Le manifestazioni cliniche possono variare.</p>
          <p>La sintomatologia acuta più frequente è rappresentata da dolore e anemia.</p>
          <p>
            Le crisi dolorose, dovute a occlusione dei vasi (VOC), possono interessare le articolazioni, l'addome e il torace, e spesso richiedono l'ospedalizzazione e la somministrazione di antidolorifici endovena. A livello toracico, il dolore è accompagnato da difficoltà respiratoria (Acute Chest Syndrome-ACS) per interessamento dei capillari polmonari. Il dolore addominale può essere legato a un coinvolgimento dell'intestino e/o della milza per infarti splenici.
          </p>
          <p>
            L'anemia, accompagnata sempre da ittero, è caratterizzata da crisi emolitiche, in concomitanza di episodi dolorosi e/o infettivi. La persistenza di crisi emolitiche può provocare un blocco momentaneo della produzione di cellule del sangue da parte del midollo osseo (crisi aplastica)
          </p>
          <p>
            Le trombosi dei vasi cerebrali, che possono colpire anche i bambini più piccoli, possono provocare dei sintomi neurologici.
          </p>
          <p>
            Le manifestazioni croniche possono essere diverse: ulcere agli arti inferiori, calcoli della colecisti, ipertensione polmonare, infezioni (polmoniti, osteomieliti, infezioni intestinali) per la riduzione dell'attività immunitaria della milza.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>Le indagini utili per la diagnosi sono:</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>L'anamnesi, l'esame emocromocitometrico, lo striscio del sangue venoso periferico, che evidenzia i GR a forma di falce; conteggio dei reticolociti, bilirubina totale e frazionata, e LDH (aumentati); aptoglobina (ridotta).</li>
            <li>Elettroforesi dell'Hb: presenza dell'HbS</li>
            <li>Diagnosi genetica: ricerca della tipica mutazione che causa la malattia</li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            La terapia si basa sulla prevenzione e il trattamento delle complicanze. La prevenzione delle crisi si effettua tramite l'utilizzo di farmaci, quali l'idrossiurea che riduce i livelli di HbS e stimola la produzione di Hb fetale (HbF) con miglioramento dell'anemia, degli episodi dolorosi. Il trattamento dell'anemia prevede le trasfusioni di GR sia in fase di acuzie che nel mantenimento cronico. Lo scambio dei GR (eritro-exchange) rappresenta una valida alternativa terapeutica. In tutti i pazienti è utile la terapia vitaminica di supporto con l'acido folico. Fondamentale è la prevenzione delle infezioni con antibiotici e vaccini contro i batteri capsulati (Streptococcus Pneumoniae, Neisseria Meningitidis, Haemophilus Influenzae B).
          </p>
          <p>
            In caso di accumulo di ferro è previsto l'impiego di farmaci ferro-chelanti. In casi selezionati può essere necessario eseguire l'asportazione della milza (splenectomia) e della colecisti. Attualmente l'unica terapia curativa è il trapianto di midollo osseo, che viene riservato nei pazienti più gravi. La terapia genica al momento non è disponibile in Europa.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La SCD ha un diverso quadro clinico a seconda dell'individuo. Generalmente si ha una stabilità clinica più o meno lunga caratterizzata da lieve anemia, interrotta da eventi acuti più o meno gravi che possono richiede l'ospedalizzazione.
          </p>
          <p>
            La prognosi della patologia varia a seconda del quadro clinico e dalla risposta ai trattamenti.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG010</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Anemie ereditarie – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico Referente:</strong> dott.ssa Michela Ribersani
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> 0649974737-735-731 (lun-ven 14,30-15,30)
            </p>
            <p className="mt-1">
              <strong>E-mail:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.site-italia.org" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Società Italiana Talassemie ed Emoglobinopatie (SITE)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 4,
      title: "Anemia aplastica acquisita",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            L'anemia aplastica acquisita o aplasia midollare è una condizione patologica caratterizzata da pancitopenia, cioè una riduzione di tutte le cellule del sangue (globuli rossi, globuli bianchi e piastrine), dovuta a ridotta o assente produzione di queste da parte del midollo osseo. Nel 70-80% dei casi l'origine è sconosciuta, mentre nei restanti casi può essere secondaria a cause infettive (soprattutto virali), esposizione a sostanze tossiche, farmaci o radiazioni. L'incidenza nel mondo occidentale è di 2 nuovi casi/anno per milione di abitanti, mentre in Oriente è tre volte più alta.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            I sintomi dell'aplasia midollare sono di entità variabile, in rapporto al grado di deficit delle cellule del sangue. Possono essere presenti i segni di anemia (pallore, stanchezza, tachicardia), della carenza di globuli bianchi (infezioni ricorrenti), e/o della carenza di piastrine (sanguinamenti di varia entità).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi è molto complessa e si deve basare su un'attenta raccolta della storia clinica del paziente e una visita accurata. L'emocromo mostra solitamente pancitopenia. L'analisi deve essere accompagnata da un agoaspirato midollare (ovvero il prelievo di un campione di sangue midollare esaminato al microscopio) e una biopsia osteomidollare (il prelievo di un frammento di osso, di solito a livello del bacino, fondamentale per la diagnosi definitiva). Questi due esami mostrano un midollo povero di cellule staminali. Infine, è molto importante eseguire ulteriori indagini per escludere altre cause di pancitopenia (come mielodisplasia, leucemia acuta ipocellulare, infezioni virali gravi, l'emoglobinuria parossistica notturna o malattie congenite come l'anemia di Fanconi o le telomeropatie).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            L'obiettivo del trattamento è il ripristino di una corretta produzione delle cellule staminali. La scelta terapeutica dipende dall'età del paziente, dalla presenza di eventuali comorbidità e dal livello di gravità dell'aplasia e, infine dalla disponibilità di un donatore di midollo.
          </p>
          <p>
            Il trattamento di prima linea nei pazienti giovani, con età inferiore a 40 anni è il trapianto di midollo osseo da donatore familiare HLA-identico (fratello o sorella). Se non disponibile, oppure il paziente ha un'età superiore a 40 anni, si utilizza la terapia immunosoppressiva, che comprende l'utilizzo combinato di siero antilinfocitario (ATG) e di ciclosporina. Per migliorare l'efficacia di questa terapia, risultati eccellenti sono stati ottenuti con l'aggiunta di un nuovo farmaco, denominato eltrombopag (Revolade), che ha dimostrato efficacia sia in prima linea che nelle recidive di malattia.  In ogni caso, è importante avviare la ricerca di un donatore non familiare nei Registri Internazionali (Matched Unrelated Donor, MUD), da poter utilizzare in caso di mancata risposta alla terapia immunosoppressiva. Un'altra strategia trapiantologica che si sta affermando negli anni più recenti è l'impiego di un donatore familiare aploidentico, ovvero parzialmente compatibile, che offre un'opzione importante di cura nei casi in cui non è possibile applicare le altre strategie terapeutiche.
          </p>
          <p>
            Di fondamentale importanza è inoltre la terapia di supporto con le trasfusioni di emazie e/o piastrine e la profilassi o il trattamento antiinfettivo per prevenire o curare le eventuali infezioni.
          </p>
          <p>
            In caso di pancitopenia lieve, o moderata, può essere seguita una strategia di osservazione ed attesa poiché in alcuni pazienti si possono ottenere remissioni spontanee senza alcun trattamento.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Il decorso della malattia è difficile da prevedere. La prognosi nella malattia severa (ovvero caratterizzata da una conta dei granulociti neutrofili inferiore a 500/mmc e piastrine inferiori a 20.000/mmc) non trattata è infausta nella maggior parte dei casi. Per questo è importante intervenire tempestivamente con la terapia di supporto e i trattamenti specifici. Per quanto riguarda il trapianto di midollo osseo, eseguito precocemente le percentuali di sopravvivenza sono eccellenti, soprattutto nei pazienti giovani (90% a 2 anni). La terapia immunosoppressiva risulta meno efficace con percentuali di risposta pari a circa il 60%. Tuttavia, le nuove strategie trapiantologiche da donatore alternativo e i nuovi farmaci (eltrombopag) hanno permesso di migliorare notevolmente le probabilità di cura. In alcuni casi possono verificarsi delle ricadute, per cui è importante che il paziente si sottoponga a regolari controlli medici.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RD0070</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per l'Anemia Aplastica Acquisita – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27A, terzo piano.
            </p>
            <p className="mt-2">
              <strong>Medici di riferimento:</strong> dott.ssa Anna Paola Iori, dott. Walter Barberi.
            </p>
            <p className="mt-2">
              <strong>Telefono:</strong> 0649974433 dalle 14 alle 16:00, dal lunedì al venerdì.
            </p>
            <p className="mt-1">
              <strong>E-mail:</strong> <span className="text-accent">ambulatoriogruppow@gmail.com</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.ematologiainprogress.it/aplasia-midollare-acquisita/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Ematologia in Progress - Aplasia Midollare Acquisita
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 5,
      title: "Anemia di Blackfan Diamond",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            L'anemia di Blackfan Diamond (ADB) è una rara aplasia eritroide congenita, condizione in cui il midollo osseo è incapace di produrre i globuli rossi, con conseguente anemia. L'incidenza annuale in Europa è di 1/150.000 e colpisce in egual modo entrambi i sessi. La trasmissione è autosomica dominante (un genitore affetto ha il 50% di possibilità di avere un figlio malato), sono rari i casi di trasmissione autosomica recessiva o legata al cromosoma X (se la madre è portatrice i figli maschi saranno nel 50% malati); in molti casi le mutazioni sono de novo, cioè si verificano nel corso della gravidanza. E' causata dalla mutazione di alcuni geni coinvolti nella produzione di proteine ribosomiali.
          </p>
          <p>
            La gravidanza nelle donne affette comporta un rischio elevato sia per la mamma che per il feto.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            I sintomi della malattia si manifestano sin dalla prima infanzia con grave anemia, che determina: pallore, sopore, dispnea durante l'allattamento, ridotta alimentazione fino a uno scarso accrescimento.
          </p>
          <p>
            La metà dei soggetti affetti presenta malformazioni congenite agli arti superiori e al pollice, anomalie cranio-facciali (palatoschisi e Sindrome di Pierre Robin), difetti cardiaci e malformazioni dell'apparato urogenitale. L'anemia di Blackfan-Diamond, predispone a insorgenza di tumori, mielodisplasia e leucemie.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            Il sospetto diagnostico deve essere posto nel caso di anamnesi familiare positiva per tale patologia (10/20% dei casi), anemia e presenza di malformazioni congenite. L'esame emocromocitometrico evidenzia uno stato di anemia con riduzione dei reticolociti. L'elettroforesi dell'emoglobina, esame non specifico, può essere utile per avvalorare la diagnosi di tale malattia, in quanto mostra un aumento dell'emoglobina fetale (HbF). Il dosaggio dell'adenosina deaminasi eritrocitaria (ADA), non specifico, può rilevare un aumento, indicativo per la diagnosi.
          </p>
          <p>
            Importante è lo studio midollare tramite agoaspirato e biopsia ossea, che evidenziano una riduzione dei precursori degli eritrociti (eritroblasti) e normalità delle altre linee cellulari.
          </p>
          <p>
            Dirimente è lo studio genetico, per identificare la presenza di mutazioni note nei geni coinvolti nell'insorgenza della malattia.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Le principali terapie sono le trasfusioni di emazie e i corticosteroidi che dovrebbero essere evitati nel primo anno di vita perché gravati da complicanze, come il ridotto accrescimento corporeo.
          </p>
          <p>
            La terapia di supporto è rappresentata da: integratori vitaminici (B12 e acido folico), che supportano il midollo nella produzione dei globuli rossi; farmaci chelanti il ferro, in quanto le continue trasfusioni possono determinare uno stato di emocromatosi (cioè un aumento eccessivo delle concentrazioni di ferro nel sangue) dannoso per l'organismo.
          </p>
          <p>
            L'unico trattamento curativo è rappresentato dal trapianto allogenico di cellule staminali emopoietiche, utilizzabile in pazienti resistenti alla terapia steroidea e/o pazienti trasfusioni-dipendenti, nel caso in cui vi sia un fratello non affetto HLA identico.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La malattia ha andamento cronico e la sua gravità varia da un individuo a un altro. L'aspettativa di vita di questi pazienti, a causa delle complicanze legate alla terapia e per il rischio di insorgenza di tumori, è ridotta.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG010</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Anemie ereditarie – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico Referente:</strong> dott.ssa Michela Ribersani
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> 0649974737-735-731 (lun-ven 14,30-15,30)
            </p>
            <p className="mt-1">
              <strong>E-mail:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="https://www.fondazionedba.org/anemia-diamond-blackfan/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Fondazione DBA
                </a>
              </li>
              <li>
                <a href="https://www.orpha.net/consor/cgi-bin/OC_Exp.php?lng=IT&Expert=124" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Orphanet
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 6,
      title: "Anemia di Fanconi",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            L'anemia di Fanconi è una malattia genetica rara caratterizzata da diverse manifestazioni cliniche, tra cui spicca la progressiva insufficienza del midollo osseo a produrre globuli rossi, globuli bianchi e piastrine. Possono essere presenti malformazioni congenite a carico di diversi organi e tessuti (ossa, reni, cuore, pelle, apparato gastrointestinale).
          </p>
          <p>
            La malattia è ereditaria ed è causata da alterazioni (mutazioni) dei geni coinvolti nella riparazione dei danni al DNA che possono verificarsi nel corso del normale funzionamento dell'organismo (processi metabolici). Nella quasi totalità dei casi, la malattia si trasmette con ereditarietà di tipo autosomico recessivo e si sviluppa quando si eredita il gene mutato da entrambi i genitori (entrambi i geni sono alterati).
          </p>
          <p>
            In una piccolissima percentuale di pazienti (1%), la malattia si trasmette attraverso il cromosoma X, uno dei due cromosomi sessuali, per cui si manifesta nei figli maschi, che hanno un solo cromosoma X e solo rarissimamente nelle femmine che possono essere affette solo se ereditano dal padre l'altro gene alterato sul cromosoma X. Fino ad oggi, sono stati identificati circa 23 geni anomali, denominati FANC, presenti in circa il 95% dei casi. La malattia può colpire entrambi i sessi, ma presenta una lieve predominanza nel sesso maschile. L'incidenza è di circa 1/136.000 nati ogni anno.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>La presentazione clinica della malattia è variabile.</p>
          <p>
            Le malformazioni congenite, presenti nel 75% dei casi, interessano solitamente: lo scheletro con ridotto accrescimento; gli arti, sia superiori che inferiori, spesso in modo asimmetrico; la cute con alterata pigmentazione (ipo e iperpigmentazioni cutanee, macchie caffè latte); le mani con ipoplasia dell'eminenza tenare (pollice); le orecchie in associazione o meno a sordità; il cuore con malformazioni; l'apparato genitourinario (rene a ferro di cavallo); l'apparato gastrointestinale; i polmoni; il SNC con microcefalia e microftalmia.
          </p>
          <p>
            Nel caso in cui tali malformazioni sono assenti, la diagnosi avviene più tardivamente con la comparsa dell'insufficienza midollare (in un primo periodo si può avere una piastrinopenia isolata e, solo in seguito, compare l'anemia associata o meno a leucopenia (riduzione dei globuli bianchi).
          </p>
          <p>
            Raramente alcuni soggetti non presentano manifestazioni cliniche congenite né alterazioni ematologiche; pertanto, la diagnosi è tardiva e si effettua nei casi di comparsa di leucemie o neoplasie (testa-collo, esofago, cute, fegato).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            Il sospetto diagnostico deve essere posto nel caso di malformazioni congenite, insufficienza midollare e comparsa di neoplasie in giovane età.
          </p>
          <p>
            Il gold standard è il test di fragilità cromosomica al diepossibutano (Test al DEB).
          </p>
          <p>
            Altri tests molto utili e specifici sono lo studio dei linfociti con la citometria, e il western blot per la proteina FANCD2.
          </p>
          <p>
            Per il completamento diagnostico è necessario eseguire l'analisi genetica per l'indentificazione del gene mutato; tale indagine viene, inoltre, utilizzata al fine di eseguire studi familiari e identificare eventuali soggetti asintomatici.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            In pazienti asintomatici è necessario effettuare un controllo periodico tramite esame emocromocitometrico e aspirato midollare.
          </p>
          <p>
            Nei pazienti sintomatici la terapia di supporto è rappresentata dalle trasfusioni di emazie concentrate e piastrine, oltre alla prevenzione delle infezioni con antibioticoterapia nei pazienti con una riduzione dei globuli bianchi.
          </p>
          <p>
            L'unica terapia curativa nel caso dell'insufficienza midollare è il trapianto allogenico di cellule staminali ematopoietiche.
          </p>
          <p>
            Necessario in questi pazienti è, inoltre, un attento monitoraggio per la maggiore incidenza di neoplasie, rispetto alla popolazione normale.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            L'anemia di Fanconi è una malattia cronica. La prognosi, spesso sfavorevole, è influenzata dall'insufficienza midollare e della comparsa di tumori in giovane età.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG010</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Anemie ereditarie – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> dott.ssa Michela Ribersani
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://airfa.it" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana per la Ricerca sull'Anemia di Fanconi (AIRFA)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 7,
      title: "Anemia diseritropoietica congenita",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            Per anemia diseritropoietica congenita (CDA) si intende un gruppo eterogeneo di anemie rare ereditarie, caratterizzate da eritropoiesi inefficace con inadeguata produzione di globuli rossi (GR) nel midollo osseo e da alterazioni strutturali dei precursori, chiamati eritroblasti, dei GR.
          </p>
          <p>
            Esistono diversi sottotipi di CDA: i tipi I e II, più frequenti soprattutto nel bacino del Mediterraneo, e i tipi III, IV (associata a riduzione delle piastrine, o piastrinopenia) e CDA variante che sono forme più rare. Non si conosce l'esatta incidenza della malattia; sono stati descritti in 42 anni circa 122 casi di CDA I e 367 di CDA II.
          </p>
          <p>
            Il tipo I e II hanno trasmissione autosomica recessiva (è necessario che entrambe i genitori siano portatori), mentre il tipo III e IV vengono trasmesse in modalità autosomica dominante (è sufficiente avere un solo gene malato perché la malattia si manifesti; un genitore ha il 50% di probabilità di trasmetterla); la CDA varianti è in genere trasmissione legata al cromosoma X (con la madre portatrice, i figli maschi hanno la probabilità del 50% di essere malati).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Nella CDA I, la sintomatologia clinica è molto variabile, sia nei diversi sottotipi che individualmente, e può manifestarsi durante l'infanzia, in giovane età e, nei casi più gravi, già in utero. In genere, i pazienti presentano anemia macrocitica o normocitica (GR con diametro aumentato), in alcuni casi subittero o ittero e aumento delle dimensioni della milza (splenomegalia); si associano spesso malformazioni congenite che possono interessare gli arti, l'articolazione dell'anca e il cranio.
          </p>
          <p>
            La CDA II, forma più frequente, è caratterizzata da anemia normocitica, con reticolociti normali o aumentati e ittero intermittente, calcoli biliari, splenomegalia, epatomegalia (aumento delle dimensioni del fegato) ed emocromatosi (accumulo di ferro in tessuti) che nel tempo determina l'insorgenza di complicanze.
          </p>
          <p>
            Nella CDA III, estremamente rara, i pazienti presentano anemia emolitica, predisposizione a gammopatia monoclonale, a mieloma multiplo e ad alterazioni retiniche che possono determinare deficit visivo.
          </p>
          <p>
            La CDA IV è caratterizzata da un aumento in circolo dei reticolociti, dalla presenza di GR con forma alterata associata alla riduzione dei valori delle piastrine (trombocitopenia).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi viene effettuata in centri ad alta specializzazione con caratterizzazione del sottotipo di CDA. Gli esami fondamentali di primo livello sono: emocromo, reticolociti e studio degli indici di emolisi (bilirubina t/d, LDH e aptoglobina). L'emocromo mostra uno stato di anemia più o meno marcata e spesso è presente un aumento della ferritina; utile è la valutazione del midollo osseo al microscopio anche se non mandatoria. Fondamentale è la diagnosi genetica che permette di identificare le mutazioni genetiche specifiche di ogni sottotipo.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            La variabilità delle manifestazioni cliniche fa sì che non tutti i pazienti necessitino di trattamento. I pazienti asintomatici eseguono soltanto controlli periodici, mentre quelli sintomatici, con anemia grave, devono essere sottoposti a frequenti trasfusioni di GR concentrati. Il trapianto di midollo osseo è una opzione terapeutica in casi selezionati; finora, è stato eseguito con successo in pochi casi descritti in letteratura.
          </p>
          <p>
            La splenectomia può risolvere o ridurre la necessità di trasfusioni in pazienti con CDA II trasfusione-dipendenti, mentre induce solo un lieve aumento dell'emoglobina (Hb) nei pazienti con CDA II non trasfusione-dipendente generalmente. Nei pazienti con CDA I, la splenectomia non sembra migliorare i livelli di Hb.
          </p>
          <p>
            In alcuni pazienti con CDA I, con mutazione genetica particolare, è risultata efficace la terapia con interferone alfa.
          </p>
          <p>
            In tutti i pazienti è indicata una terapia di supporto con vitamine del gruppo B e l'acido folico. Nei casi di aumento della ferritina si impiegano farmaci chelanti del ferro per via orale (deferiprone)
          </p>
          <p>
            Attualmente, sono in studio per queste forme di anemia nuovi farmaci (ex. Luspatercept) e la terapia genica.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Sono patologie croniche con anemia associata all'insorgenza di complicanze: calcoli biliari, anemizzazione acuta secondaria a infezioni, emocromatosi, ulcere agli arti inferiori ed ematopoiesi extra-midollare (cioè formazione di aree di produzione di GR al di fuori del midollo osseo).
          </p>
          <p>
            La prognosi è estremamente variabile. È in genere buona ma l'aspettativa di vita può essere leggermente ridotta e soprattutto gravata dalle complicanze.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG010</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Anemie ereditarie – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico Referente:</strong> dott.ssa Michela Ribersani
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> 0649974737-735-731 (lun-ven, 14,30-15,30)
            </p>
            <p className="mt-1">
              <strong>E-mail:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://astem.it" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione STEM
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 8,
      title: "Anemia sideroblastica congenita",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            Le anemie sideroblastiche sono un gruppo di anemie caratterizzate da una ridotta produzione di globuli rossi da parte del midollo osseo, determinata da un alterato utilizzo del ferro da parte delle cellule del midollo osseo e/o da una sintesi difettosa dell'emoglobina.
          </p>
          <p>
            Si differenziano in forme congenite e forme acquisite, che fanno parte delle sindromi mielodisplastiche.
          </p>
          <p>
            L'anemia sideroblastica congenita è caratterizzata da un difetto genetico che determina un'alterata produzione dell'eme.
          </p>
          <p>
            Le forme congenite si suddividono in sindromiche e non sindromiche.
          </p>
          <p>
            Le anemie sideroblastiche sindromiche comprendono:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>L'anemia sideroblastica associata a miopatia mitocondriale: caratterizzata da una progressiva intolleranza all'attività fisica ed acidosi lattica. La trasmissione è autosomica recessiva.</li>
            <li>L'anemia sideroblastica associata a immunodeficienza, febbre periodica, ritardo dello sviluppo.</li>
            <li>L'anemia megaloblastica sensibile alla tiamina, associata a diabete mellito tipo II, sordità neurosensoriale.</li>
            <li>La sindrome di Pearson: anemia sideroblastica con alterazione dei precursori nel midollo ed insufficienza pancreatica esocrina.</li>
            <li>L'anemia sideroblastica legata al cromosoma X ed atassia. Rara forma in cui allo stato di anemia si associa atassia (ritardo motorio) e disartria (difficoltà ad articolare le parole).</li>
          </ul>
          <p>
            Le anemie sideroblastiche non sindromiche possono avere trasmissione autosomica recessiva, o legata all'X e presentare sideroblasti ad anello.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Ai sintomi specifici di ogni forma si associa comunemente uno stato di anemia, più o meno severo, e di emocromatosi cioè l'accumulo di ferro in organi e tessuti che può determinare l'insorgenza di aritmie, infarto, cirrosi, splenomegalia, iperpigmentazione cutanea, iperglicemia, intolleranza glucidica.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            Tali patologie devono essere sospettate in bambini che presentano all'esame emocromocitometrico anemia microcitica e/o ipocromica e sovraccarico di ferro documentato da aumento della ferritina, della transferrina e dell'IST (indice di saturazione della transferrina).
          </p>
          <p>
            Lo studio morfologico, tramite microscopio, del sangue venoso periferico può evidenziare la presenza di siderociti (globuli rossi contenenti ferro non emoglobinico) e l'aumento dei reticolociti (precursori dei globuli rossi e indicatori di aumentata attività midollare).
          </p>
          <p>
            Lo studio midollare con l'agoaspirato permette di evidenziare la presenza di sideroblasti ad anello (cioè precursori dei globuli rossi che presentano un accumulo di ferro).
          </p>
          <p>
            Per una corretta diagnosi delle forme congenite di malattia bisogna indentificarne le mutazioni con lo studio genetico.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Il trattamento è eterogeneo. La maggior parte di questi pazienti sono trasfusione-dipendenti. Una terapia di supporto necessaria è la ferro-chelazione al fine di ridurre i livelli ematici di ferro (aumentato oltre che per la patologia di base anche per le continue trasfusioni).
          </p>
          <p>
            Alcune forme come quella legata all'X rispondono al trattamento con piridossina ed acido folico.
          </p>
          <p>
            In caso di gravi sintomi il trapianto di cellule staminali emopoietiche risulta efficace.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            L'andamento clinico di queste patologie è cronico e varia da una forma all'altra. L'aspettativa di vita e la prognosi di questi pazienti è simile a quella degli individui sani, nonostante lo stile di vita venga influenzato dalle continue trasfusioni.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG010</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Anemie ereditarie – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico Referente:</strong> dott.ssa Michela Ribersani
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> 0649974737-735-731 (lun-ven 14,30-15,30)
            </p>
            <p className="mt-1">
              <strong>E-mail:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="https://www.ail.it/patologie-e-terapie/patologie-ematologiche/leucemia/591-anemia-sideroblastica" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  AIL - Anemia Sideroblastica
                </a>
              </li>
              <li>
                <a href="https://www.orpha.net/consor/cgi-bin/OC_Exp.php?Expert=75563&lng=IT" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Orphanet
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 9,
      title: "Atransferrinemia congenita",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            L'atransferrinemia congenita è una rarissima malattia ematologica a trasmissione autosomica recessiva, ovvero una situazione in cui vengono ereditate due copie mutate di un gene, una dalla madre ed una dal padre. È causata da un deficit della transferrina (una proteina che trasporta ferro nel sangue), dovuta al mutazioni del gene che codifica la transferrina che è localizzato sul cromosoma 3. Il deficit o addirittura l'assenza di tale proteina provoca un mancato o ridotto rilascio di ferro utile per la sintesi dell'emoglobina, con conseguente anemia e deposito di ferro nei tessuti (emocromatosi secondaria).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            L'esordio della malattia avviene o nel periodo neonatale o nella prima infanzia con segni caratteristici dell'anemia, quali pallore, affaticamento, inappetenza, irritabilità, ritardo della crescita e tachicardia. Inoltre, possono essere presenti anche manifestazioni dovute al sovraccarico di ferro, quali sofferenza epatica fino alla cirrosi e insufficienza cardiaca.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi di atransferrinemia congenita si basa sul dosaggio dei livelli sierici di transferrina inferiori a 35 mg/dl e anemia. La conferma della diagnosi si ottiene con l'analisi molecolare che identificano le mutazioni del gene che codifica per la molecola della transferrina. La diagnosi prenatale è possibile in caso di una preventiva identificazione delle mutazioni nella famiglia.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Il trattamento dell'atrasferrinemia consiste nell'esecuzione di flebotomie associate ad infusioni di apotransferrina purificata (transferrina priva di ferro), che permettono di eliminare il ferro in eccesso (riducendo il danno da sovraccarico) e ristabilire i livelli di trasferrina, permettendo l'adeguata formazione dell'emoglobina e la correzione dell'anemia. Questa terapia va eseguita per tutta la vita, non essendo al momento disponibile un trattamento alternativo curativo.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Tale patologia può essere letale in assenza di trattamento. La prognosi dipende dalla precocità della diagnosi e del trattamento e dalla gravità delle lesioni d'organo causate dall'accumulo di ferro.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RC0130</p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.orpha.net/it/disease" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Orphanet
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 10,
      title: "Disordini ereditari trombofilici",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            Si tratta di difetti o alterazioni genetiche di uno o di più fattori della coagulazione che causano una eccessiva facilità alla coagulazione del sangue. È definita come trombofilia ereditaria la presenza di una o più tra le seguenti anomalie:
          </p>

          <ul className="list-disc pl-5 space-y-1">
            <li>deficit delle proteine anticoagulanti naturali: antitrombina (AT), proteina C (PC), proteina (PS);</li>
            <li>presenza in forma eterozigote o omozigote delle mutazioni a carico del gene che codifica per il fattore V (mutazione G1691A, fattore V Leiden), del fattore II (mutazione G20210A) della coagulazione;</li>
            <li>disfibrinogenemia</li>
          </ul>

          <p>
            La carenza congenita di antitrombina viene trasmessa con carattere autosomico dominante e determina un aumento di 25 volte di sviluppare complicanze tromboemboliche rispetto alla popolazione generale. Si riconosce un difetto quantitativo (tipo I) e un difetto qualitativo (tipo II).
          </p>

          <p>
            La carenza congenita della proteina C può essere quantitativa (tipo I) e qualitativa (tipo II) in cui la proteina ha una funzione alterata. Le manifestazioni cliniche sono estremamente variabili, tra le più gravi: la purpura fulminans e la necrosi cutanea.
          </p>

          <p>
            La carenza di Proteina S è trasmessa con carattere autosomico dominante ed è associata a un rischio tre volte aumentato di sviluppare eventi tromboembolici. Vi sono tre tipi: il tipo I (deficit quantitativo), il tipo II (deficit qualitativo) e il tipo III in cui vi è una riduzione della forma circolante.
          </p>

          <p>
            La presenza della mutazione (G1691A) del gene che codifica per il fattore V (fattore V Leiden), sia in forma eterozigote che omozigote, predispone a un maggior rischio trombotico. I soggetti eterozigoti hanno un rischio 8 volte superiore di sviluppare una trombosi venosa, mentre per quelli omozigoti è di circa 80 volte. Tale variante ha una frequenza dell'1,4-4,2% in Europa; in Italia, i portatori eterozigoti sono circa il 2-3%.
          </p>

          <p>
            La mutazione G20210A del fattore II è associata ad elevati livelli di protrombina funzionale nel plasma e conseguente aumentato rischio di trombosi, in particolare di circa 2-3 volte superiore nei soggetti eterozigoti e di circa 6 in quelli omozigoti. La frequenza genica della variante è bassa (1,0-1,5%) con una percentuale di eterozigoti del 2-3%. L'omozigosi è rara.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Questi disordini si possono manifestare come episodi trombotici spontanei in età precoce o secondari ad intervento chirurgico, prolungata immobilità, terapia estroprogestinica, gravidanza. Generalmente si tratta di trombosi venose (trombosi venosa profonda, embolia polmonare), spesso recidivanti. Le forme più gravi, dovute a carenza della proteina C, si possono presentare come trombosi del microcircolo di vari organi anche in epoca neonatale (purpura fulminans neonatalis). Uno stato di trombofilia ereditaria può anche associarsi a poliabortività.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi si esegue dopo una accurata anamnesi familiare mediante prelievo di sangue venoso periferico. Il paziente deve essere sottoposto ad uno screening trombofilico che includa PT, PTT fibrinogeno, AT, resistenza alla proteina C attivata (APCr), PC, PS, F V Leiden, FIIG20210A. Le forme di trombofilia acquisita comprendono il dosaggio dell'omocisteinemia, LAC, anticorpi anticardiolipina, antiBeta2 glicoproteina.
          </p>

          <p className="font-medium mt-4">A chi effettuare lo screening trombofilico congenito</p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Pazienti con trombosi venosa profonda e/o embolia polmonare con età &lt; 45 anni</li>
            <li>Pazienti con anamnesi familiare positiva per tromboembolismo venoso e/o embolia polmonare in età giovanile</li>
            <li>Pazienti con trombosi nel distretto addominale o cerebrale</li>
            <li>Donne con complicanze ostetriche (poliabortività, morte intrauterina feto, eclampsia)</li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            I pazienti portatori di anomalie ereditarie trombofiliche hanno un aumentato rischio di sviluppare un primo evento tromboembolico in determinate situazioni (interventi chirurgici, traumi, periodi di immobilizzazione prolungata, allettamenti, gravidanza, terapia estroprogestinica). Per questi pazienti è possibile instaurare in queste situazioni una profilassi anticoagulante.
          </p>

          <p>
            Coloro che invece hanno già sviluppato un evento trombotico necessitano di una terapia anticoagulante per un periodo definito o indefinito, a secondo della persistenza o meno di altri fattori di rischio, del tipo di anomalia, del numero e tipo degli eventi pregressi.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La diagnosi precoce e la profilassi nelle situazioni di aumentato rischio trombotico permettono di ridurre, in maniera significativa, le complicanze trombotiche.
          </p>

          <p>
            I pazienti con trombosi, se trattati con adeguata terapia anticoagulante, hanno buona prognosi.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG020</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Trombofile (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27a, piano terra e 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medici di riferimento:</strong> dott. Antonio Chistolini, dott.ssa Cristina Santoro, dott.ssa Erminia Baldacci.
            </p>
            <p className="mt-2">
              <strong>Telefono:</strong> 0649974413, dalle 8.30 alle 14:00, dal lunedì al venerdì.
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://fcsa.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Sito FCSA (Federazione Centri per la diagnosi della trombosi e sorveglianza terapie anticoagulanti)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 11,
      title: "Emocromatosi ereditaria",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            L'emocromatosi ereditaria, detta anche emocromatosi primitiva o emocromatosi idiopatica, è una patologia ereditaria rara, causata da difetti nei meccanismi di regolazione del metabolismo del ferro che portano ad un progressivo accumulo di ferro nell'organismo con conseguente danno a carico di alcuni organi. In Italia, la prevalenza di tale malattia varia a seconda dell'area geografica, da 1 caso ogni 500 abitanti nel Nord a 1 ogni 2000-3000 abitanti nel Centro-Sud e nelle Isole.
          </p>
          <p>
            Si distinguono 4 forme:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>
              <span className="font-medium">Emocromatosi di tipo 1</span> è dovuta a mutazione del gene HFE, che codifica per una proteina fondamentale nella regolazione dell'assorbimento del ferro. È la forma più comune. Si trasmette con modalità autosomica recessiva (cioè il malato ha entrambi i geni alterati, mentre il portatore sano ha un solo gene alterato e l'altro gene normalmente funzionante). In genere si manifesta prima dei 30 anni.
            </li>
            <li>
              <span className="font-medium">Emocromatosi di tipo 2</span> è più rara della precedente ed è conosciuta anche come emocromatosi giovanile, perché si manifesta, in forma grave, già in età giovanile. Anche questa forma si trasmette con modalità autosomica recessiva. Si distinguono due sottotipi, in base al gene coinvolto: tipo 2a, dovuta a mutazioni del gene che codifica per l'emojuvelina, un co-recettore che attiva l'espressione di HAMP; tipo 2b, dovuta a mutazioni del gene HAMP che codifica per l'epcidina, una piccola proteina (peptide) che regola l'assorbimento intestinale del ferro e il rilascio di questo dalle cellule.
            </li>
            <li>
              <span className="font-medium">Emocromatosi di tipo 3</span> è causata da mutazioni del gene del recettore della transferrina (TFR2). È molto rara e si trasmette con modalità autosomica recessiva.
            </li>
            <li>
              <span className="font-medium">Emocromatosi di tipo 4</span> è dovuta a mutazioni del gene della ferroportina (o ceruloplasmina), una proteina che regola l'uscita di ferro dalla cellula della mucosa intestinale e dalle cellule di deposito del ferro. Si trasmette in modo autosomico dominante (cioè, basta un solo gene alterato per provocare la malattia).
            </li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Le manifestazioni cliniche in genere compaiono dopo i 40-50 anni, ad eccezione dell'emocromatosi di tipo 2 in cui compaiono prima dei 30 anni, e sono legate ad un danno d'organo provocato da un eccessivo accumulo di ferro. All'inizio i sintomi non sono specifici, mentre negli stadi più avanzati diventano molto gravi:
          </p>

          <div className="mt-4">
            <ul className="space-y-3">
              <li className="flex">
                <span className="font-semibold w-32">Fegato:</span>
                <span>Fibrosi, Cirrosi</span>
              </li>
              <li className="flex">
                <span className="font-semibold w-32">Pancreas:</span>
                <span>Diabete Mellito</span>
              </li>
              <li className="flex">
                <span className="font-semibold w-32">Cuore:</span>
                <span>Aritmie, Insufficienza cardiaca</span>
              </li>
              <li className="flex">
                <span className="font-semibold w-32">Asse Ipofisi-Gonadi:</span>
                <span>Ipogonadismo, Ginecomastia, Amenorrea</span>
              </li>
              <li className="flex">
                <span className="font-semibold w-32">Apparato osteo-articolare:</span>
                <span>Artropatia emocromatosica, Osteoporosi</span>
              </li>
              <li className="flex">
                <span className="font-semibold w-32">Cute:</span>
                <span>Iperpigmentazione (colorito bronzino)</span>
              </li>
              <li className="flex">
                <span className="font-semibold w-32">Tiroide:</span>
                <span>Ipotiroidismo</span>
              </li>
            </ul>
          </div>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi di emocromatosi si sospetta sulla base dell'incremento della sideremia a digiuno, della ferritina sierica (&gt;200 ng/mL nelle donne; &gt;250 ng/mL negli uomini) e dell'indice di saturazione della transferrina (&gt;45%) e/o per la presenza di eventuali manifestazioni cliniche.
          </p>
          <p>
            L'incremento dell'indice va confermato su tre prelievi consecutivi, distanziati di 20 giorni l'uno dall'altro. Escluse altre possibili cause di emocromatosi (es. anemie ereditarie, sindrome metabolica, epatopatie alcoliche, eccessiva assunzione di ferro), deve essere eseguito lo studio genetico per l'identificazione delle mutazioni dei geni associati allo sviluppo di emocromatosi. Una volta fatta la diagnosi, si esegue la risonanza magnetica per valutare l'accumulo di ferro nel fegato, pancreas, cuore, milza e ipofisi. Altre indagini utili a valutare le condizioni del fegato sono la SQUID (superconducting quantum interference device) utile a quantificare il ferro epatico e la fibroelastografia (Fibroscan®) che permette la valutazione non invasiva della fibrosi epatica. In casi selezionati è indicata la biopsia epatica per determinare il danno epatico, a scopo prognostico.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            La terapia si basa principalmente sulla flebotomia (salassoterapia), che rappresenta il trattamento di prima scelta e che ha lo scopo di rimuovere il ferro in eccesso prima che si accumuli nei tessuti. Ogni 500 ml di sangue rimosso vengono eliminati 250 mg di ferro elementare. In caso di intolleranza o controindicazioni alla flebotomia, si può seguire una terapia basata su farmaci ad attività ferro-chelante (Deferasirox, Deferoxamina, Deferipone). Solo in casi selezionatissimi, si può proporre l'eritrocitoaferesi. Qualsiasi sia il trattamento, è importante seguire una dieta povera di alimenti ricchi di ferro e l'astensione dall'alcool (per prevenire o ridurre il danno epatico).
          </p>
          <p>
            Dal 2015, inoltre, i pazienti senza danno d'organo, possono eseguire un mantenimento basato su donazione di sangue.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            L'andamento clinico e la prognosi dei pazienti dipendono strettamente dall'entità dell'accumulo marziale al momento della diagnosi e dell'inizio della terapia. I pazienti privi di manifestazioni alla diagnosi hanno una qualità e un'aspettativa di vita simile a quella della popolazione generale, mentre la prognosi dei pazienti con segni/sintomi è peggiore.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">
              RCG100 - L'esenzione viene rilasciata a tutti i pazienti con mutazione in omozigosi C282Y di HFE e ai pazienti con mutazioni diverse e segni/sintomi da accumulo di ferro.
            </p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Dott.ssa Stefania Trasarti, Centro di riferimento regionale per l'Emocromatosi – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione adulti, piano terra.
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita, telefonare allo:</strong> 0649974757, dalle 14:00 alle 15:00, dal lunedì al venerdì.
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.emocromatosi.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione per lo Studio dell'Emocromatosi e delle Malattie da Sovraccarico di Ferro
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 12,
      title: "Emofilia",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            È una coagulopatia di origine genetica, dovuta ad un difetto quantitativo di uno specifico fattore della coagulazione, in particolare il fattore VIII (FVIII) (emofilia A) e il fattore IX (FIX) (emofilia B).
          </p>
          <p>
            Questa malattia si eredita con modalità recessiva attraverso il cromosoma X poiché in esso sono localizzati i geni che codificano per questi fattori. Per tale motivo la patologia si manifesta esclusivamente nei maschi mentre le femmine sono quasi sempre portatrici sane.
          </p>
          <p>
            L'emofilia A è la forma più diffusa ed è causata da una carenza del FVIII della coagulazione. Ha un'incidenza di un caso ogni 5.000-10.0000 nati maschi.
          </p>
          <p>
            L'emofilia B, definita anche malattia di Christmas, è provocata da una carenza del FIX. Ha un'incidenza di 1 caso ogni 30.000 nati maschi.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Il quadro clinico è simile per entrambe le forme. La sintomatologia emorragica varia in relazione ai livelli del fattore carente. Se l'attività del fattore è inferiore all'1% si parla di emofilia grave, se la percentuale è compresa tra 1-5% si parla di emofilia di tipo moderato, se compresa tra il 5-40% si parla di emofilia lieve.
          </p>
          <p>
            Le principali manifestazioni cliniche sono la formazione di emartri (sanguinamenti intra-articolari) ed ematomi. L'emartro viene considerato il sintomo cardine della patologia ed interessa principalmente le articolazioni dei gomiti, ginocchia e caviglie. Il ripetersi degli emartri può dare luogo a quella che viene definita artropatia emofilica, una forma di artrosi molto precoce caratterizzata da rigidità articolare e danno funzionale irreversibile. L'ematoma ha invece come localizzazione tipica il muscolo ileopsoas.
          </p>
          <p>
            Le persone con emofilia grave possono avere inoltre sanguinamenti spontanei o post traumatici anche in altri distretti anatomici, tra cui quello cerebrale, gastro-intestinale, polmonare (emoftoe), a livello del cavo orale e dell'apparato urinario. Nella forma grave le manifestazioni emorragiche compaiono precocemente. Inoltre si possono presentare sanguinamenti post-chirurgici.
          </p>
          <p>
            I pazienti con emofilia lieve o moderata più frequentemente vanno incontro solo ad emorragie post-traumatiche o post-chirurgiche.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            Il sospetto diagnostico viene posto quando il bambino che inizia a muovere i primi passi e a gattonare, presenta una sintomatologia emorragica caratterizzata da ematomi e anche emartri. Viene quindi eseguita in prima istanza un'attenta anamnesi familiare seguita da una coagulazione di base che metterà in evidenza un allungamento isolato del tempo di tromboplastina parziale (aPTT).
          </p>
          <p>
            La conferma definitiva si ha mediante dosaggio del fattore della coagulazione carente e la ricerca della specifica mutazione genica responsabile della malattia. Nelle famiglie in cui siano presenti casi di emofilia è possibile sottoporre le donne all'analisi del DNA per stabilire se ne siano portatrici sane o effettuare la diagnosi prenatale nelle gravidanze a rischio.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Il trattamento dell'emofilia avviene attraverso la somministrazione del concentrato del fattore coagulativo carente per via endovenosa a dosi e intervalli variabili.
          </p>
          <p>
            La terapia dell'emofilia può essere eseguita in profilassi con lo scopo di prevenire le emorragie gravi o a fronte del sintomo emorragico (on-demand).
          </p>
          <p>
            Il "gold standard" della terapia dell'emofilia è la profilassi "long-term" che inizia nella prima infanzia e prosegue nell'età adulta.
          </p>
          <p>
            Attualmente oltre alla terapia sostitutiva con prodotti ad emivita standard, abbiamo a disposizione anche dei concentrati di FVIII e FIX ad emivita prolungata e per l'emofilia A grave anche una terapia non sostitutiva. Si tratta di un anticorpo monoclonale bispecifico (emicizumab) che mima l'attività del FVIII; è un trattamento molto efficace e si somministra per via sottocutanea in pazienti senza e con inibitore.
          </p>
          <p>
            Inoltre, nell'emofilia A lieve può essere somministrato un derivato dell'ormone antidiuretico (DDAVP) che incrementa i livelli endogeni di FVIII.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Attualmente grazie alle terapie e alla profilassi l'artropatia emofilica è una problematica quasi completamente risolta nelle nuove generazioni di pazienti. Invece persiste come complicanza della terapia sostitutiva la comparsa nel paziente di anticorpi diretti contro il FVIII o FIX, che ne neutralizzano l'effetto e che possono rendere inefficace il trattamento. Per i pazienti affetti da emofilia A con inibitore attualmente è possibile eseguire la profilassi con l'emicizumab. Per i pazienti con emofilia B e inibitore sono in sperimentazione nuove molecole.
          </p>
          <p>
            Grazie alla profilassi i bambini e le loro famiglie sono in grado di condurre una vita normale.
          </p>
          <p>
            È opportuno che i soggetti affetti da emofilia evitino situazioni che possono facilmente provocare emorragie e l'assunzione di farmaci che interferiscono con la funzione piastrinica (aspirina e farmaci antinfiammatori non steroidei).
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG020</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di Riferimento e Coordinamento Regionale per le Malattie Emorragiche (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27a, 1° piano.
            </p>
            <p className="mt-2">
              <strong>Referenti:</strong> Dott.ssa Cristina Santoro, Dott.ssa Erminia Baldacci, Dott. Antonio Chistolini
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita per adulti e bambini scrivere a:</strong>
            </p>
            <p className="text-accent mt-1">
              gruppogz@gmail.com
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="space-y-2 mt-2">
              <li>
                <a href="https://aiceonline.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Centri Emofilia (AICE)
                </a>
              </li>
              <li>
                <a href="https://fedemo.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Federazione delle Associazioni Emofilici (FedEmo)
                </a>
              </li>
              <li>
                <a href="https://www.fondazioneparacelso.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Fondazione Paracelso (associazione pazienti)
                </a>
              </li>
              <li>
                <a href="https://www.aelonlus.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Emofilici Lazio (AEL)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 13,
      title: "Emoglobinuria parossistica notturna",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            L'emoglobinuria parossistica notturna (EPN) è una rara patologia causata dalla mutazione acquisita nel gene PIG-A, situato sul cromosoma X. Tale mutazione determina la perdita di una proteina necessaria per l'ancoraggio sulla membrana dei globuli rossi di alcune proteine (CD59 e CD55), che determinano l'inibizione della lisi del globulo rosso mediata dal complemento (un meccanismo di difesa del nostro organismo).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            L'EPN, che si caratterizza per un'emolisi cronica, nonostante il termine "parossistica, si manifesta con crisi emolitiche piò o meno gravi, che possono essere causate da eventi scatenanti come infezioni o stress psico-fisici, con conseguente anemia ed emissione di urine scure (emoglobinuria, per perdita di emoglobina nelle urine). L'aumentata attivazione del complemento e l'emolisi possono inoltre aumentare il rischio di trombosi, con manifestazioni cliniche diverse a seconda dei vasi sanguigni colpiti. Un'alterata funzione midollare può associarsi all'EPN, determinando pancitopenia (carenza di globuli rossi, globuli bianchi e piastrine nel sangue).
          </p>
          <p>
            Le manifestazioni cliniche principali sono stanchezza, pallore, affanno, febbre, dolore addominale, vomito e cefalea.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            L'EPN va sospettata sulla base delle manifestazioni cliniche, di un'anemia con indici di emolisi (incremento dell'LDH, della bilirubina indiretta e dei reticolociti, riduzione dell'aptoglobina), associata o meno a carenza di globuli bianchi e piastrine, la presenza di emoglobinuria nelle urine e la comparsa di eventi trombotici in sedi anomale, in assenza di stati trombofilici.
          </p>
          <p>
            La diagnosi definitiva si fa sulle cellule ematiche. ottenute con un prelievo di sangue venoso, avvale della citofluorimetria a flusso, una tecnica che permette di evidenziare l'assenza delle proteine CD59 e CD55 sulla superficie. L'agoaspirato midollare (un prelievo di sangue midollare) viene eseguito se si vogliono escludere altre patologie ematologiche associate (es. mielodisplasia, aplasia).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            La terapia dell'emoglobinuria parossistica notturna si avvale degli inibitori del complemento (anticorpi monoclonali come l'eculizumab e il ravulizumab) che consentono di ridurre l'emolisi, con conseguente miglioramento dell'anemia e riduzione del fabbisogno trasfusionale, fino ad ottenere, in alcuni pazienti, l'indipendenza trasfusionale. Tali farmaci riducono, inoltre, l'incidenza di eventi trombotici, ma non agiscono sulla citopenia dovuta all'insufficienza midollare. Per un aumento del rischio di infezioni, i pazienti che ricevono questo tipo di trattamento devono essere sottoposti a vaccinazione per batteri capsulati (Haemophilus Influenzae, meningococco e pneumococco) e/o a terapia antibiotica di profilassi. In caso di crisi emolitiche, alcuni pazienti possono necessitare di supporto trasfusionale.
          </p>
          <p>
            La terapia anticoagulante è riservata ai pazienti che hanno manifestato trombosi acute, mentre il suo impiego in profilassi è ancora controverso.
          </p>
          <p>
            I pazienti completamente asintomatici non necessitano di alcun trattamento.
          </p>
          <p>
            Ad oggi, il trapianto allogenico di midollo osseo rimane l'unica terapia curativa, ma l'elevato rischio di mortalità limita questa procedura terapeutica a quei casi dove l'aspetto aplastico o mielodisplastico sono dominanti.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            L'EPN è un disordine con andamento cronico. Fino all'introduzione nel trattamento di questi pazienti degli inibitori del complemento, la sopravvivenza media era di circa 10-15 anni, e gli eventi trombotici erano la principale causa di morte. Con l'introduzione nella pratica clinica dell'eculizumab, l'aspettativa di vita di questi pazienti si è allungata notevolmente, raggiungendo quella della popolazione normale.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RD0020</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per l'Emoglobinuria Parossistica Notturna – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27A, terzo piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> dott.ssa Anna Paola Iori.
            </p>
            <p className="mt-2">
              <strong>Telefono:</strong> 0649974433 dalle 14 alle 16:00, dal lunedì al venerdì.
            </p>
            <p className="mt-1">
              <strong>E-mail:</strong> <span className="text-accent">ambulatoriogruppow@gmail.com</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://aiepn.it" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  AIEPN Onlus, Associazione Italiana Emoglobinuria Parossistica Notturna
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 14,
      title: "Istiocitosi a cellule di Langerhans",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            L'istiocitosi a cellule di Langerhans (ICL) è una malattia rara, clonale, acquisita (non ereditaria), sistemica. È caratterizzata da una proliferazione e accumulo di istiociti anomali, chiamati cellule di Langerhans, che esprimono antigeni particolari, che la differenziano da altri disordini istiocitari (Istiocitosi non Langerhans, malattia di Rosai Dorfman, malattia di Erdheim-Chester). L'ICL è la più frequente tra i disordini istiocitari cronici.
          </p>
          <p>
            Gli istiociti sono cellule del sangue che normalmente svolgono un'importante funzione fagocitaria, insieme ai macrofagi, durante le infezioni e/o infiammazioni. L'identificazione della mutazione BRAFV600E e di altri geni mutati ha dimostrato che le cellule di Langerhans dell'ICL sono cellule neoplastiche clonali che originano da cellule progenitrici mieloidi aberranti. L'accumulo degli istiociti può coinvolgere qualsiasi organo o tessuto determinando un danno.
          </p>
          <p>
            Può presentarsi a tutte le età, ma è più frequente in età pediatrica, con un'incidenza annuale di circa 2,6-8,9 casi per milione nei bambini di età inferiore a 15 anni e 1-2 casi per milione negli adulti.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            La malattia può essere localizzata, soprattutto a livello osseo o cutaneo, oppure diffusa con interessamento multiorgano. I sintomi possono essere sistemici e aspecifici (febbre, astenia, riduzione della crescita) oppure dovuti ad una disfunzione del/degli organo/i coinvolto/i. Lo scheletro è il sistema più frequentemente colpito (80/90% dei pazienti), con lesioni che determinano dolori e/o tumefazioni. In 1/3 dei pazienti è presente una localizzazione cutanea, con vescicole, dermatiti e prurito. Il cavo orale può essere coinvolto, più frequentemente negli adulti, con lesioni dell'osso mandibolare o mascellare e/o ulcerazioni della mucosa gengivale e/o avulsione dei denti. Il coinvolgimento polmonare, con noduli e/o cisti e bolle e/o fibrosi, si riscontra soprattutto nei pazienti adulti fumatori, mentre nei bambini nel contesto di una malattia multi-sistemica. Una localizzazione nel midollo osseo, con anemia, riduzione del numero delle piastrine (piastrinopenia) e riduzione dei globuli bianchi (leucopenia) è raro negli adulti, mentre può verificarsi nei bambini con malattia disseminata.
          </p>
          <p>
            Si può riscontrare un aumento di volume della milza (splenomegalia) e del fegato (epatomegalia), con alterata funzionalità epatica.
          </p>
          <p>
            Il sistema nervoso centrale può essere coinvolto in circa il 20-50% dei pazienti con ICL. La manifestazione più frequente è il diabete insipido, caratterizzato da poliuria (emissione di elevate quantità di urine) e polidipsia (sensazione di sete intensa) dovuto a compromissione dell'ipofisi. Le masse tumorali occupanti spazio sono rare così come le lesioni neurodegenerative, che possono comparire anche a distanza di anni dalla diagnosi della malattia.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi di certezza si basa sull'esame istologico, tramite biopsia, del tessuto interessato che permette l'identificazione delle cellule di Langerhans, istiociti atipici positivi per le proteine di superficie della cellula CD1a, CD207 (langerina) e S100. È inoltre fondamentale la ricerca della mutazione BRAFV600E e di altri geni, importanti per un adeguato approccio terapeutico.
          </p>
          <p>
            Posta la diagnosi di ICL, è necessario eseguire indagini strumentali (Rx dei distretti scheletrici coinvolti o scintigrafia ossea, Rx ortopanoramica, ecografia addome, tomografia assiale computerizzata (TC), risonanza magnetica (RM) per valutare l'estensione e la gravità della malattia, indagini ematochimiche per individuare alterazioni ematiche, endocrine, epatiche e renali, e visite specialistiche (visita odontoiatrica, visita pneumologica, visita endocrinologica). L'agoaspirato midollare va eseguito solo in caso di una sospetta localizzazione di malattia nel midollo osseo.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Gli obiettivi del trattamento sono: (a) indurre la regressione della malattia; (b) prevenirne le riattivazioni; (c) evitare la tossicità e le sequele tardive. In alcuni casi particolari non è previsto alcun trattamento (wait and watch) poiché le lesioni possono regredire spontaneamente. Nei casi in cui è necessario, si decide il trattamento in base all'estensione e gravità della malattia: terapia locale (iniezione intralesionale di corticosteroidi, curettage chirurgico, radioterapia) in caso di lesioni ossee isolate, oppure terapia sistemica (mono o polichemioterapia, cortisonici, vemurafenib, inibitori di altre chinasi, indometacina, interferone, etc). Per le forme polmonari isolate dell'adulto l'astensione assoluta dal fumo può provocare un miglioramento. Nelle forme multisistemiche e/o con interessamento di organi particolari è indicata la chemioterapia con i seguenti farmaci: vinblastina, vincristina, 6-mercaptopurina, metotrexate, citarabina, cladribina, clofarabina.
          </p>
          <p>
            È da tener presente che in genere vengono utilizzati protocolli diversi negli adulti e nei bambini.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Il decorso della malattia è variabile: da forme che possono regredire anche spontaneamente a forme disseminate multiorgano potenzialmente fatali.
          </p>
          <p>
            Nei pazienti adulti tende ad avere un andamento cronico.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RCG150</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Istiocitosi (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> (Bambini) dott.ssa Giovanna Palumbo, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.istiocitosi.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Ricerca Istiocitosi Onlus (AIRI)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 15,
      title: "Istiocitosi Non-Langerhans",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            Le istiocitosi a cellule non-Langerhans (o neoplasie istiocitiche) sono un gruppo eterogeneo di malattie rare acquisite (non ereditarie) che rientrano nei disordini degli istiociti, cellule del sistema immunitario presenti in molti tessuti dell'organismo. Sono patologie caratterizzate dall'accumulo di istiociti atipici, con caratteristiche diverse dalle cellule di Langerhans, in vari organi e/o tessuti. Questo gruppo comprende: lo xantogranuloma giovanile, la malattia di Erdheim-Chester (si rimanda alla sezione specifica), la malattia di Rosai-Dorfman (si rimanda alla sezione specifica), l'istiocitosi ALK-positiva e il sarcoma istiocitico.
          </p>
          <p>
            Lo xantogranuloma giovanile è la forma più comune di Istiocitosi a cellule non-Langerhans, rara ma non eccezionale e benigna. È caratterizzata da lesioni cutanee, prevalentemente localizzate sulla testa e sul collo, presenti alla nascita o che compaiono di solito nel primo anno di vita (raramente in età adulta), che in genere regrediscono spontaneamente. Sono stati descritti casi con interessamento della mucosa orale, dell'occhio e dei polmoni. E' eccezionale il coinvolgimento del sistema nervoso centrale (diabete insipido), delle ossa e degli altri organi.
          </p>
          <p>
            L'istiocitosi ALK-positiva si contraddistingue per la presenza di un'alterazione del gene ALK che codifica per una proteina cellulare implicata nella proliferazione delle cellule. Può colpire qualsiasi fascia di età. Il quadro clinico è eterogeneo, con forme che possono interessare uno o più organi e/o tessuti. Frequente è il coinvolgimento del sistema nervoso, centrale o periferico, e della cute. Nei neonati, tipicamente, coinvolge il fegato, la milza e/o il midollo osseo.
          </p>
          <p>
            Il sarcoma istiocitico è una neoplasia maligna estremamente rara, più frequente in età adulta. Può coinvolgere esclusivamente i linfonodi o, nella maggior parte dei casi, altre sedi, quali il tratto intestinale, la cute e i tessuti molli.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Lo xantogranuloma giovanile cutaneo si presenta con una o più papule, meno frequentemente noduli, di colorito rossastro o giallastro, di diametro variabile da meno di un millimetro fio a 2 cm. Le lesioni a carico della mucosa orale possono apparire verrucose, peduncolate o simili a fibromi. Un'emorragia nella camera anteriore dell'occhio (ifema) o un glaucoma possono essere i segni di una compromissione oculare.
          </p>
          <p>
            Nell'istiocitosi ALK-positiva i sintomi dipendono dall'organo colpito. Anemia e piastrinopenia compaiono in caso di coinvolgimento del midollo osseo, che in genere è accompagnato da aumento di volume del fegato (epatomegalia) con o senza alterazione della funzionalità e della milza (splenomegalia). In caso di coinvolgimento del sistema nervoso i sintomi possono essere cefalea, vomito, atassia, crisi convulsive, ipotonia, torcicollo, diplopia, nevralgia del trigemino, paresi.
          </p>
          <p>
            Nel sarcoma istiocitico frequentemente sono presenti sia sintomi sistemici, quali stanchezza, inappetenza, dimagrimento, sudorazione notturna e febbre, sia sintomi relativi all'organo colpito, quali aumento di volume dei linfonodi (linfoadenopatia), dolori ossei, epatosplenomegalia, anemia, riduzione dei globuli bianchi (leucopenia) e piastrinopenia, dolori addominali, alvo irregolare e occlusione intestinale.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi di certezza si basa sull'esame istologico, tramite biopsia, del tessuto interessato che permette l'identificazione di istiociti atipici con caratteristiche diverse dalle cellule di Langerhans. Si raccomanda la ricerca dell'alterazione del gene ALK nei disordini istiocitari che non corrispondono a entità definite. In considerazione dell'estrema rarità del sarcoma istiocitico è importante che l'esame istologico della biopsia venga condotto presso un'anatomia patologica con esperienza specifica.
          </p>
          <p>
            Posta la diagnosi, le ulteriori indagini da eseguire dipendono dal tipo di malattia.
          </p>
          <p>
            Per quanto riguarda lo xantogranuloma giovanile è consigliabile eseguire una visita oculistica e un'ecografia dell'addome completo.
          </p>
          <p>
            Nel caso dell'istiocitosi ALK-positiva è utile effettuare valutazioni specialistiche, indagini ematochimiche e strumentali (ecografia, TC, RM, PET-TC) per determinare l'estensione della malattia e la funzionalità degli organi.
          </p>
          <p>
            Essendo una malattia estremamente aggressiva, il paziente con diagnosi di sarcoma istiocitico deve essere seguito in un centro specializzato in questo tipo di patologie, in grado di offrire un approccio multidisciplinare, non solo diagnostico ma anche terapeutico.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Lo xantogranuloma giovanile solitamente regredisce da solo, pertanto il trattamento non è spesso necessario e la rimozione non è di solito raccomandata.
          </p>
          <p>
            Il trattamento dell'istiocitosi ALK-positiva è variabile e dipende dalla sede e dall'estensione della malattia. Resezione, chirurgica, terapia locale, radioterapia, chemioterapia sono stati finora utilizzati da soli o in associazione. L'uso di farmaci inibitori di ALK ha dimostrato come questo tipo di istiocitosi si contraddistingua per una notevole risposta a questo tipo di trattamento mirato.
          </p>
          <p>
            Il trattamento del sarcoma istiocitico prevede la resezione chirurgica e/o la chemioterapia e/o la radioterapia.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Lo xantogranuloma giovanile solitamente migliora e regredisce da solo nell'arco di 3-6 anni. Alla sua scomparsa a livello cutaneo può rimanere una cicatrice o un'alterazione della pigmentazione.
          </p>
          <p>
            Nell'istiocitosi ALK-positiva, gli inibitori di ALK determinano risposte buone e durature nel tempo, anche nei pazienti trattati in recidiva.
          </p>
          <p>
            Il sarcoma istiocitico è una patologia molto aggressiva e la risposta alla terapia è scarsa, con una sopravvivenza mediana di alcuni mesi nei pazienti con malattia disseminata. Tuttavia, con una gestione clinica e terapeutica adeguata, i pazienti con forme localizzate hanno una buona prognosi con una lunga sopravvivenza.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RCG150</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Istiocitosi (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> (Bambini) dott.ssa Giovanna Palumbo, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.istiocitosi.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Ricerca Istiocitosi Onlus (AIRI)
                </a>
              </li>
              <li className="mt-1">
                <a href="https://www.retesarcoma.it/sarcoma-istiocitico" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Fondazione Paola Gonzato Rete Sarcoma ETS
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 16,
      title: "Malattia di Castleman",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La malattia di Castleman è una malattia rara acquisita (non ereditaria), che comprende un gruppo eterogeneo di disordini linfoproliferativi che hanno tutti le stesse caratteristiche istopatologiche. Può manifestarsi a qualsiasi età. La caratteristica è l'ingrossamento di uno o più linfonodi (linfoadenomegalie) associati o meno a sintomi sistemici come febbre e stanchezza, dovuti ad un aumento di proteine infiammatorie (citochine), in particolare dell'interleuchina-6 (IL-6). È frequente il riscontro di manifestazioni cliniche su base autoimmune. Alcune forme multicentriche sono associate a infezione da Human Immunodeficiency Virus (HIV) e/o da Herpesvirus-8 (HHV8).
          </p>
          <p>
            In base al numero delle stazioni linfonodali coinvolte e, nelle forme multicentriche non dovute all'HIV, alla presenza o assenza dell'HHV-8, possiamo distinguere:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              La forma unicentrica, caratterizzata da un aumento di volume di un singolo linfonodo o di una stazione linfonodale
            </li>
            <li>
              La forma multicentrica, in cui sono coinvolte più stazioni linfonodali e comprende:
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>La forma associata ad HHV8 (MCD HHV8+)</li>
                <li>
                  La forma HHV8 negativa (MCD HHV8-), che, a sua volta, comprende:
                  <ul className="list-disc pl-6 space-y-2 mt-2">
                    <li>
                      La MCD idiopatica (iMCD), con due sottotipi:
                      <ul className="list-disc pl-6 space-y-2 mt-2">
                        <li>Classico, iMCD-NOS (not otherwise specified)</li>
                        <li>iMCD-TAFRO, caratterizzata da riduzione delle piastrine (trombocitopenia), anasarca, mielofibrosi, febbre, disfunzione renale e aumento delle dimensioni de fegato e/o della milza (epatomegalia e/o splenomegalia).</li>
                      </ul>
                    </li>
                    <li>MCD-POEMS, caratterizzata da polineuropatia, epato e/o splenomegalia, endocrinopatia, picco monoclonale, alterazioni cutanee [skin]).</li>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Nella forma unicentrica le sedi più comunemente coinvolte sono i linfonodi toracici (in particolare mediastinici), laterocervicali e addominali. Il coinvolgimento dei linfonodi mediastinici si manifesta con segni e sintomi tipici: difficoltà respiratoria, tosse, ostruzione dei vasi venosi.
          </p>
          <p>
            Nella forma multicentrica, i sintomi sono variabili a seconda del sottotipo. Oltre alle linfoadenopatie coinvolgenti sedi multiple e ai sintomi sistemici, possono essere presenti epatomegalia e/o splenomegalia, con edemi e versamenti, anemia, riduzione dei globuli bianchi (leucopenia), trombocitopenia e alterazione della funzionalità epatica e renale. Nella forma i-CMD TAFRO sono presenti trombocitopenia, edemi diffusi, fibrosi del midollo osseo, febbre, disfunzione renale ed epatosplenomegalia e nella sindrome MCD POEMS si riscontrano alterazione di nervi periferici, epatosplenomegalia, alterazioni del sistema endocrino, alterazione delle proteine del sangue, alterazioni cutanee.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi si basa sull'esame istologico della biopsia del linfonodo interessato. Fondamentale è anche la ricerca dei virus HIV e HHV8 nel linfonodo per la diagnosi differenziale fra la forma multicentrica HHV8-associata e quella idiopatica.
          </p>
          <p>
            Posta la diagnosi istologica, per poter caratterizzare il tipo e l'estensione della malattia, è necessario eseguire indagini ematochimiche (emocromo, coagulazione, funzionalità renale ed epatica, proteina C reattiva, VES, fibrinogeno, elettroforesi e immunofissazione sierica e ferritina, autoimmunità, dosaggio IL-6), virologiche (sierologia HIV e carica virale dell'HHV8 su sangue venoso periferico), strumentali (ecografia, PET/TC). La biopsia osteomidollare è utile per escludere altre malattie ematologiche, quali linfoma e mieloma.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Nella forma unicentrica il trattamento standard curativo è l'escissione chirurgica completa. Se non è praticabile, si adoperano altri tipi di terapia locale (radioterapia, embolizzazione) o terapia sistemica con anticorpi anti-CD20 (rituximab) e anti-IL-6 (siltuximab), in caso di uno stato infiammatorio acuto.
          </p>
          <p>
            Nella forma multicentrica la terapia di prima linea si basa su un anticorpo monoclonale, il siltuximab, associato o meno a terapia corticosteroidea. Altre opzioni terapeutiche sono rappresentate da corticosteroidi, rituximab, talidomide, lenalidomide, bortezomib, ciclosporina, sirolimus, interferone e chemioterapia "lymphoma-like".
          </p>
          <p>
            Nella forma multicentrica associata ad HHV8 in assenza della positività per HIV, il rituximab, associato o meno a chemioterapia, rappresenta la terapia di scelta; in alcuni casi si è dimostrata efficace l'associazione con terapia antivirale, valganciclovir.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La forma unicentrica ha un andamento benigno, mentre quella multicentrica può avere un decorso clinico variabile, da indolente ad aggressivo.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">Ancora priva di codice di esenzione.</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I.
            </p>
            <p className="mt-2">
              Dott.ssa Giovanna Palumbo, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
            <p className="mt-2">
              Dott.ssa Alice Di Rocco, Via Benevento 27A, 2° piano.
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.amicaodv.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  AMICa ODV
                </a>
              </li>
              <li className="mt-1">
                <a href="https://castleman.eu/it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Euro Castleman
                </a>
              </li>
              <li className="mt-1">
                <a href="https://www.cdcn.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Castleman Disease Collaborative Network (CDCN)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 17,
      title: "Malattia di Erdheim-Chester",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La malattia di Erdheim-Chester è una neoplasia rara degli istiociti, cellule del sistema immunitario presenti in molti tessuti dell'organismo. È caratterizzata dall'accumulo di istiociti atipici, schiumosi, che provocano un danno a livello dei vari organi e/o tessuti interessati. E' molto frequente la presenza di una mutazione dell'oncogene BRAF o di altri geni che codificano alcune proteine, chiamate chinasi.
          </p>
          <p>
            La sua incidenza è sconosciuta, colpisce prevalentemente gli adulti, soprattutto tra 40 e 70 anni, mentre sono eccezionali i casi in età pediatrica.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Le manifestazioni cliniche sono estremamente eterogenee in quanto la malattia può colpire molti organi e tessuti.
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Il coinvolgimento osseo (80% dei pazienti), con lesioni addensanti soprattutto a livello di femore e tibia, può causare dolore persistente.
            </li>
            <li>
              L'apparato cardiovascolare (restringimento dell'aorta, infiltrazione del tessuto circostante e della parete cardiaca, coinvolgimento del pericardio e più raramente delle coronarie) è presente nel 50-70% dei casi, con sintomatologia variabile.
            </li>
            <li>
              La compromissione polmone, presente nel 50% dei casi, può provocare dispnea e tosse.
            </li>
            <li>
              Il coinvolgimento neurologico può essere dovuto a infiltrazione da malattia oppure a lesioni neurodegenerative, che possono colpire il cervelletto, con una sintomatologia che dipende dalle sedi coinvolte. Ci può essere un interessamento della ghiandola ipofisi con poliuria (emissione di elevate quantità di urine) e polidipsia (sensazione di sete intensa) e/o di altre ghiandole endocrine.
            </li>
            <li>
              La localizzazione renale è tipica perché coinvolge i tessuti circostanti, con dilatazione dell'uretere (idroureteronefrosi) fino all'insufficienza renale.
            </li>
            <li>
              La caratteristica dell'interessamento della cute è la presenza di xantelasmi (accumulo di istiociti a livello palpebrale) e xantomi (accumulo di istiociti in altre sedi cutanee).
            </li>
          </ul>
          <p>
            Possono inoltre essere presenti sintomi, come febbre, astenia e dimagrimento.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi di certezza si basa sull'esame istologico, tramite biopsia, del tessuto interessato che permette l'identificazione di istiociti schiumosi o ricchi di lipidi, positivi per le proteine di superficie della cellula CD68 e CD163, come quelli dell'istiocitosi a cellule di Langerhans, ma negativi per CD1a e langerina (CD207).
          </p>
          <p>
            Importante è la ricerca della mutazione del gene BRAF -V600E o di altri geni che codificano per le proteine della via delle MAPK (mitogen-activated protein kinases), via di segnale coinvolta nella patogenesi della malattia.
          </p>
          <p>
            Per valutare il grado dell'interessamento multiorgano sono necessarie le seguenti indagini: indagini ematochimiche ed endocrinologiche, radiografia e/o scintigrafia ossea, valutazione cardiologica con eventuale risonanza magnetica cardiaca, visita pneumologica con prove di funzionalità respiratoria, risonanza magnetica dell'encefalo, visita neurologica ed endocrinologica. La PET/TC totale corporea è l'esame d'elezione sia alla diagnosi che durante il trattamento, per valutare la risposta.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Nella malattia di Erdheim-Chester il cortisone è indicato per migliorare i sintomi acuti. Attualmente sono disponibili diversi farmaci. Nei pazienti che presentano la mutazione del gene BRAF-V600E (circa il 60%) è indicato il trattamento con vemurafenib, che inibisce il gene anomalo. Nei pazienti BRAF-negativi, può essere utilizzato l'interferone alfa (IFN-α). Nei pazienti che non rispondono al vemurafenib o sono resistenti/intolleranti a terapia con interferone sono disponibili farmaci inibitori delle MAPK chinasi (cobimetinib e trametinib), la cladribina, o farmaci immunosoppressori, quali il sirolimus.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Le sedi colpite e l'estensione della malattia condizionano il decorso clinico; il coinvolgimento cardiovascolare, polmonare e neurologico sono associati a una cattiva prognosi.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RCG150</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Istiocitosi (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> dott.ssa Giovanna Palumbo
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://erdheim-chester.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  ECD Global Alliance
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 18,
      title: "Malattia di Gaucher",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La malattia di Gaucher (MG) è una rara malattia metabolica ereditaria che fa parte di un gruppo di malattie da accumulo lisosomiale, chiamate sfingolipidosi, in cui si verifica un accumulo di lipidi in alcuni organuli, chiamati lisosomi, che si trovano all'interno delle cellule. La MG si trasmette con ereditarietà di tipo autosomico recessivo e si sviluppa quando si ereditano le copie mutate del gene da entrambi i genitori.
          </p>
          <p>
            Finora sono state descritte oltre 500 mutazioni del gene che codifica per un enzima, β-glucocerebrosidasi o β-glucosidasi (GBA), la cui carenza determina un accumulo nei lisosomi dei macrofagi di una sostanza grassa non digerita, la β-glucosilceramide, provocando un danno e/o un ingrossamento di alcuni organi e/o tessuti. Le manifestazioni cliniche sono estremamente variabili e possono essere presenti alla nascita o in età adulta.
          </p>
          <p>
            Si distinguono tre diversi tipi:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Il tipo 1 (forma non neuropatica) con sintomi simili a quelli di una malattia ematologica;</li>
            <li>Il tipo 2 (forma neuropatica acuta), con un gravissimo e rapidamente progressivo coinvolgimento neurologico, accompagnato da sintomi simil ematologici;</li>
            <li>Il tipo 3 (forma neuropatica cronica), con un coinvolgimento neurologico eterogeneo e lentamente progressivo, con o senza sintomi ematologici.</li>
          </ul>
          <p>
            La sua prevalenza è stimata da 1/40.000 (tipo 1) a 1/150.000 (tipi 2 e 3) individui in tutto il mondo; mentre nella popolazione ebraica ashkenazita è 1/800.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            La MG di tipo 1 può manifestarsi con sintomi simili a quelli di una malattia ematologica quali aumento di volume della milza (splenomegalia) e meno frequentemente del fegato, riduzione del numero delle piastrine (piastrinopenia), anemia, riduzione dei globuli bianchi (leucopenia), dolori e/o fratture ossee.
          </p>
          <p>
            Nella forma neuropatica acuta (tipo 2) i sintomi neurologici (spasticità, paralisi oculare, associati ad alterazione della deglutizione e della respirazione) con importante aumento di volume della milza e del fegato sono presenti sin dalla nascita.
          </p>
          <p>
            La forma neuropatica cronica (tipo 3) è caratterizzata da sintomi neurologici, quale il nistagmo, disturbi uditivi e della deambulazioni, crisi epilettiche, che possono comparire nei primi anni di vita.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi si basa sul dosaggio dell'enzima β-glucocerebrosidasi su sangue venoso periferico. In caso di carenza dell'enzima, la diagnosi deve essere completata con la ricerca del/dei tipo/i di mutazione a carico del gene codificante l'enzima.
          </p>
          <p>
            Per valutare il grado di interessamento dei diversi organi si eseguono indagini ematochimiche e strumentali (ecografia addome, mineralometria ossea della colonna vertebrale e del femore e radiografia dei distretti ossei coinvolti, risonanza magnetica dell'encefalo) visita neurologica, cardiologica e pneumologica.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            La terapia è disponible ed efficace nella MG di tipo 1, dal momento che i farmaci attualmente disponibili non agiscono sulla compromissione neurologica, che caratterizza i tipi 2 e 3.
          </p>
          <p>
            Vi sono due tipi di terapia con meccanismi di azione differenti. La terapia enzimatica sostitutiva consiste nella somministrazione endovenosa dell'enzima mancante ottenuto in laboratorio; i farmaci attualmente disponibili sono: l'imiglucerasi (cerezyme), velaglucerasi alfa (VPRIV) e taliglucerasi (non registrato in Europa). La terapia di riduzione del substrato comprende due farmaci con un meccanismo d'azione diverso: il miglustat (zavesca) è un inibitore aspecifico, mentre l'eliglustat (cerdelga) è un potente inibitore specifico della sintesi di glucosilceramide, che impedisce l'accumulo intralisosomiale. Questo farmaco è somministrato per via orale.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Nel tipo 1 il trattamento precoce consente una normalizzazione di tutti i parametri e una normale aspettativa e qualità di vita. Il tipo 2 è a prognosi infausta nella prima infanzia. Nel tipo 3 la prognosi è legata al grado di coinvolgimento neurologico.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RCG080</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per la malattia di Gaucher (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> dott.ssa Giovanna Palumbo
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.gaucheritalia.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Gaucher
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 19,
      title: "Malattia di Rosai-Dorfman",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La malattia di Rosai-Dorfman è una malattia rara acquisita (non ereditaria), che coinvolge gli istiociti, cellule del sistema immunitario presenti in molti tessuti dell'organismo e che normalmente svolgono un'importante azione di difesa dalle infezioni. La proliferazione e l'accumulo di istiociti atipici, con caratteristiche diverse dalle cellule di Langerhans, avviene all'interno dei linfonodi e dei vasi linfatici di organi interni.
          </p>
          <p>
            La patologia può, quindi, interessare sia i linfonodi che altri organi e/o tessuti, quali la regione testa-collo (prime vie aeree, orbite, e cavo orale), sistema nervoso, cute, polmone, cuore, apparato genitourinario, apparato gastrointestinale, osso. La sua prevalenza è di circa 1:200.000 casi, può comparire a qualsiasi età ma è più frequente nei bambini e nei giovani adulti.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            I sintomi sono variabili e dipendono dalle sedi coinvolte. Nella maggior parte dei casi è presente un aumento di volume dei linfonodi, soprattutto a livello del collo. In caso di interessamento a livello di altri organi e/o tessuti, possiamo riscontrare:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Dismorfie (deformità) del volto, esoftalmo (anormale sporgenza degli occhi dalle orbite), alterazioni a carico della mucosa della bocca o della lingua in caso di coinvolgimento della regione testa-collo;
            </li>
            <li>
              Dispnea (difficoltà a respirare) per ipertrofia adenoidea e/o tonsillare o per impegno polmonare, in cui può essere presente anche tosse, o per coinvolgimento cardiaco;
            </li>
            <li>
              Cefalea, convulsioni, disturbi dell'andatura e/o della sensibilità, nistagmo emiparesi, diabete insipido per compromissione del sistema nervoso centrale;
            </li>
            <li>
              Dolori addominali e/o costipazione, per localizzazione intestinale;
            </li>
            <li>
              Dolore lombare ed ematuria per localizzazione renale;
            </li>
            <li>
              Dolori con o senza tumefazione a carico dell'osso;
            </li>
            <li>
              Prurito con noduli, papule in caso di interessamento della cute.
            </li>
          </ul>
          <p>
            Possono essere presenti sintomi sistemici, quali stanchezza, febbre, sudorazione notturna e perdita di peso.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi di certezza si basa sull'esame istologico, tramite biopsia, del linfonodo e/o del tessuto interessato, con cui è possibile identificare una dilatazione dei seni linfonodali con infiltrato di istiociti caratterizzati dalla positività per le proteine di superficie della cellula S100, fascina e CD14 e negatività per le proteine CD1a e CD207, che la distingue dalle istiocitosi a cellule di Langerhans. Altra caratteristica tipica, ma non specifica, è il fenomeno dell'emperipolesi che consiste nella presenza di linfociti intatti e vitali nel citoplasma della maggior parte degli istiociti.
          </p>
          <p>
            Posta la diagnosi, per valutare l'estensione della malattia è necessario eseguire una serie di indagini ematochimiche, strumentali (ecografia, TC, RX, RM) e visite specialistiche (pneumologica, cardiologica, etc.).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Attualmente, non esistono approcci uniformi e il trattamento è individualizzato. Le strategie terapeutiche variano dall'osservazione, ai corticosteroidi, alla chirurgia, alla radioterapia e alla chemioterapia. L'approccio "watch and wait" (osservazione senza trattamento) è indicato per le localizzazioni linfonodali che non causano effetto massa o per altre localizzazioni asintomatiche.
          </p>
          <p>
            I corticosteroidi hanno un'efficacia transitoria sui sintomi e le dimensioni delle masse di origine linfatica (linfonodi, tonsille, adenoidi). La chirurgia eradicante è indicata nelle forme unifocali.
          </p>
          <p>
            La chemioterapia è riservata alle forme refrattarie o riattivate e, in prima, alle forme disseminate con sintomi. I farmaci più adoperati sono: alcaloidi della vinca, basse dosi di metotrexate e 6-mercaptopurina, cladribina, clofarabina e immunomodulanti.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La valutazione della risposta al trattamento va eseguita entro 4-6 mesi dall'inizio della terapia.
          </p>
          <p>
            La prognosi è generalmente favorevole, specialmente per le forme linfonodali e cutanee, che spesso presentano un andamento autolimitante. In alcuni casi, la malattia può presentare un decorso più imprevedibile, nel quale possono alternarsi periodi di remissione e di riattivazioni in un arco di tempo molto variabile. I pazienti con malattia multifocale o extranodale presentano una prognosi meno favorevole.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RCG150</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Istiocitosi (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> (Bambini) dott.ssa Giovanna Palumbo, Via Benevento 6, 1° piano, Accettazione-ambulatorio pediatrico.
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.istiocitosi.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Ricerca Istiocitosi Onlus (AIRI)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 20,
      title: "Malattia di Von Willebrand",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La malattia di von Willebrand rappresenta il più frequente disordine emorragico ereditario, colpendo circa l'1-2% della popolazione (1 ogni 800-1.000 nati) indipendentemente dal sesso, ed è dovuto alla mutazione di un gene localizzato sul braccio corto del cromosoma 12 che comporta una carenza del fattore von Willebrand (vWF) o una sua inadeguatezza funzionale.
          </p>
          <p>
            La modalità di trasmissione di questa patologia può essere autosomica dominante o recessiva, a seconda della specifica tipologia di difetto.
          </p>
          <p>
            Il vWF viene prodotto dalle cellule endoteliali e dai megacariociti, ed ha le seguenti funzioni: contribuire all'adesione piastrinica all'endotelio danneggiato, favorire l'aggregazione piastrinica, trasportare il fattore VIII (FVIII) e proteggerlo dalla degradazione enzimatica. Dunque, un difetto qualitativo o quantitativo del vWF determina un eccessivo sanguinamento dovuto sia alle ridotte concentrazioni del FVIII che all'alterata adesione e aggregazione piastrinica.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            I pazienti affetti da questa condizione sono soggetti soprattutto a sanguinamenti muco-cutanei, in particolare ecchimosi anche dopo traumi di lieve entità, epistassi intense e prolungate, gengivorragie. Frequenti sono le emorragie gastroenteriche e le donne possono andare incontro a meno-metrorragie (cicli mestruali abbondanti e prolungati). I pazienti con difetto grave possono anche sperimentare emartri (sanguinamenti intra-articolari).
          </p>
          <p>
            La malattia, a seconda del tipo di deficit, viene classificata in tre tipologie principali:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              Il tipo 1, in cui si ha un difetto quantitativo parziale di vWF ed interessa il 75% dei pazienti affetti da questa malattia.
            </li>
            <li>
              Il tipo 2, in cui si ha un difetto qualitativo del fattore del vWF e si suddivide a sua volta in quattro sottotipi (2A, 2B, 2M, 2N).
            </li>
            <li>
              Il tipo 3, in cui si ha un difetto quantitativo grave per completa assenza del vWF.
            </li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            Tutte le volte che il paziente presenta emorragie muco-cutanee significative, emorragie prolungate per ferite lievi, epistassi o emorragie gastroenteriche spontanee vi è indicazione a eseguire alcuni test di laboratorio. In particolare, saranno indicativi il tempo di emorragia o il suo surrogato, il tempo di chiusura, e il tempo di tromboplastina parziale attivato che risulteranno in genere allungatati; il test di aggregazione piastrinica alla ristocetina potrà risultare ridotto, o incrementato nel caso di malattia di von Willebrand tipo 2B.
          </p>
          <p>
            Di fondamentale importanza è il dosaggio dell'attività del vWF attraverso il test del cofattore ristocetinico e il dosaggio dell'antigene del vWF che risulteranno ridotti. Una volta conclusa la diagnosi è consigliabile uno screening familiare per individuare altri possibili membri affetti.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Nel tipo 1, 2A, 2M viene in genere utilizzata la desmopressina somministrata per via endovenosa o sottocutanea che determina il rilascio in circolo del vWF da parte dei depositi delle cellule endoteliali.
          </p>
          <p>
            Nel tipo 2B e nel tipo 3 ci si avvale di una terapia sostitutiva con concentrati che contengono il FVIII e il vWF.
          </p>
          <p>
            Nelle forme più gravi il trattamento può essere eseguito in profilassi, ovvero somministrando il concentrato di FVIII/vWF 2-3 volte a settimana.
          </p>
          <p>
            Gli antifibrinolitici possono essere utilizzati per sanguinamenti minori o comunque in associazione alla desmopressina e se necessario anche al concentrato di FVIII/vWF.
          </p>
          <p>
            I pazienti necessitano di essere trattati sia a domanda ma soprattutto in profilassi di interventi chirurgici, estrazioni dentarie e manovre invasive.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La malattia di von Willebrand tipo 1 e tipo 2 ha un andamento benigno caratterizzato da una sintomatologia variabile anche da paziente a paziente. Inoltre la terapia sostitutiva e la desmopressina somministrate all'occorrenza o in profilassi, sono terapie molto efficaci.
          </p>
          <p>
            La malattia di von Willebrand tipo 3 ha delle manifestazioni emorragiche più gravi, ma che comunque con una profilassi regolare e a lungo termine possono essere controllate. L'insorgenza di inibitore contro il vWF è un evento molto raro, e che colpisce fondamentalmente solo i pazienti affetti da malattia di von Willebrand tipo 3.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG020</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di Riferimento e Coordinamento Regionale per le Malattie Emorragiche (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27a, 1° piano.
            </p>
            <p className="mt-2">
              <strong>Referenti:</strong> Dott.ssa Cristina Santoro, Dott.ssa Erminia Baldacci, Dott. Antonio Chistolini
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita per adulti e bambini scrivere a:</strong> <span className="text-accent">gruppogz@gmail.com</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="https://aiceonline.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Centri Emofilia (AICE)
                </a>
              </li>
              <li>
                <a href="https://fedemo.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Federazione delle Associazioni Emofilici (FedEmo)
                </a>
              </li>
              <li>
                <a href="https://www.fondazioneparacelso.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Fondazione Paracelso (associazione pazienti)
                </a>
              </li>
              <li>
                <a href="https://www.aelonlus.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Emofilici Lazio (AEL)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 21,
      title: "Mastocitosi",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La mastocitosi è una patologia rara acquisita, caratterizzata da un'anomala proliferazione e accumulo di mastociti (particolari cellule immunitarie prodotte dal midollo osseo) nella cute e in altri organi e tessuti.
          </p>
          <p>
            La mastocitosi è attualmente classificata in:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>Mastocitosi cutanea</strong>, quando i mastociti infiltrano solo la cute. È più frequente nei bambini. Le lesioni cutanee, uniche o multiple, possono avere forma e dimensioni diverse: chiazze di color salmone o bruno (maculo-papule), piccoli pallini di colore scuro (noduli), vesciche, bolle, placche.
            </li>
            <li>
              <strong>Mastocitosi sistemica</strong>, quando i mastociti proliferano, oltre che nella cute, anche in altri organi e tessuti (midollo osseo, tratto gastrointestinale, polmone, fegato, milza e linfonodi. È la forma più rara e tende a comparire nell'adulto tra i 20 e i 50 anni di età). In molti casi di mastocitosi sistemica sono presenti mutazioni a carico di un gene, chiamato c-KIT che produce una proteina (KIT) che funziona da legante di un fattore di crescita che regola la proliferazione e la maturazione cellulare. Le mutazioni a carico del gene c-KIT provocano un'attivazione spontanea della proteina KIT con conseguente anomala proliferazione dei mastociti.
            </li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            La sintomatologia può essere variabile. Se presente, è dovuta principalmente al rilascio da parte dei mastociti di molecole, tra cui l'istamina e la triptasi, che provocano prurito, vampate di calore, o reazioni allergiche più gravi, anche anafilattiche. Il prurito può essere scatenato da cambiamenti di temperatura, uso di alcuni farmaci, consumo di cibi piccanti e bevande calde o alcoliche, esercizio fisico. Questi sintomi possono comparire sia nelle forme cutanee che in quelle sistemiche.
          </p>
          <p>
            Nelle forme sistemiche possono essere presenti sia sintomi aspecifici (stanchezza, cefalea, perdita di peso) che quelli da infiltrazione di organi o tessuti (crampi o dolori addominali diffusi, nausea, vomito, bruciore gastrico, diarrea, emorragie gastrointestinali, dolori articolari e ossei diffusi, fratture ossee, aumento di volume del fegato e della milza, anemia).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            L'attenta analisi delle lesioni cutanee e la valutazione dei sintomi è importante per l'orientamento diagnostico. Nella mastocitosi cutanea maculo-papulare, lo sfregamento delle lesioni determina la comparsa di gonfiore, eritema e prurito della lesione: questo fenomeno prende il nome di segno di Darier ed è caratteristico di questa forma.
          </p>
          <p>
            Il dosaggio della triptasi (una proteina prodotta dai mastociti) nel sangue è di fondamentale importanza nella diagnosi e risulta, in genere, alta nella mastocitosi sistemica e normale nelle forme cutanee. La conferma della diagnosi è data dalla presenza di mastociti anomali in una lesione cutanea analizzata e/o in un organo coinvolto e/o nel midollo osseo.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            È importante la prevenzione dei sintomi causati dalle sostanze secrete dai mastociti, evitando i fattori scatenanti (stimoli meccanici, stress fisici ed emotivi, particolari tipi di farmaci e cibi).
          </p>
          <p>
            Essendo una malattia che può avere caratteristiche e andamento clinico diversi, la terapia varia in base al tipo, all'età, alle condizioni di salute del paziente.
          </p>
          <p>
            La mastocitosi cutanea spesso non richiede trattamento. In alcuni casi, può essere indicato l'uso di creme e pomate a base di cortisone o la terapia con raggi ultravioletti dell'area interessata (fototerapia).
          </p>
          <p>
            Il trattamento dei sintomi da rilascio delle sostanze secrete dai mastociti prevede l'uso di antistaminici, di antiacidi e sodio cromoglicato.
          </p>
          <p>
            Nella mastocitosi sistemica possono essere utilizzati diversi farmaci, quali:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Cortisonici per via sistemica associati, nelle forme più gravi, ai chemioterapici</li>
            <li>Farmaci target che inibiscono la proteina anomala prodotta (midostaurina, imatinib)</li>
          </ul>
          <p>
            Nelle forme più aggressive può essere utilizzato il trapianto di midollo osseo nei soggetti giovani e la splenectomia (rimozione chirurgica della milza).
          </p>
          <p>
            Nel caso di complicanze ossee, è indicato un trattamento mirato per l'osteoporosi.
          </p>
          <p>
            Per tutti i pazienti è indicata la prescrizione di adrenalina autoiniettabile, farmaco salvavita, in caso di comparsa di reazioni anafilattiche potenzialmente fatali (abbassamenti improvvisi di pressione, disturbi respiratori, dolori addominali e svenimenti).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Nella maggior parte dei bambini la mastocitosi cutanea tende a regredire spontaneamente prima della pubertà. La mastocitosi sistemica può avere un andamento indolente e cronico, oppure più aggressivo fino a forme avanzate che sono resistenti a qualsiasi trattamento.
          </p>
          <p>
            È importante che il paziente con mastocitosi sia seguito in un centro di riferimento per la malattia, che può avvalersi della collaborazione di diversi specialisti.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RD0081</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per la Mastocitosi (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento (Bambini):</strong> dott.ssa Giovanna Palumbo, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento (Adulti):</strong> Prof Massimo Breccia, Via Benevento 27a, III piano
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.asimas.it/new_asimas/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Mastocitosi
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 22,
      title: "Neutropenia",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            Per neutropenia si intende una riduzione dei granulociti neutrofili (GN) nel sangue, al di sotto di 1500/m³. La neutropenia viene classificata in lieve (GN: 1000-1500/mm³), moderata (GN: 500-1000/mm³), grave (GN: &lt; 500/mm³). Se di grave entità, è caratterizzata da un aumentato rischio di infezioni batteriche o fungine.
          </p>
          <p>
            Questa condizione può essere causata da molteplici fattori, tra cui infezioni, malattie autoimmuni, processi infiltrativi del midollo osseo, alcuni farmaci, sostanze tossiche e carenze nutrizionali. Esistono, inoltre, forme di neutropenia familiari, associate ad alterazioni genetiche. Queste comprendono:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>La neutropenia congenita grave</strong>, un'immunodeficienza, caratterizzata da una conta di neutrofili minore di 200/mcL. Alla base di questa condizione, sono state indentificate le mutazioni di diversi geni, tra cui le più frequenti sono quella di ELANE (trasmesso con modalità autosomica dominante, per la quale una persona eredita una copia normale da un genitore e una copia mutata dall'altro genitore, ma il gene mutato domina sulla copia normale), e di HAX1 (trasmesso con modalità autosomica recessiva, situazione in cui entrambe le copie del gene sono mutate). La combinazione di queste mutazioni provoca un difetto nella produzione dei neutrofili. Le infezioni caratteristiche di questa forma possono essere gravi o addirittura letali. Circa il 15% dei pazienti presenta un'evoluzione verso leucemia;
            </li>
            <li>
              <strong>La neutropenia ciclica</strong> è un raro disturbo congenito, causato dalla mutazione del gene ELANE, trasmesso con modalità autosomica dominante. La patologia è caratterizzata da periodiche oscillazioni del numero dei neutrofili circolanti (con un periodo oscillatorio di circa 20 giorni);
            </li>
            <li>
              <strong>La neutropenia cronica idiopatica grave</strong> è un tipo di neutropenia in cui il resto del sistema immunitario sembra rimanere del tutto intatto; anche con conte di neutrofili &lt; 200/mcL di solito non si verificano infezioni gravi, probabilmente perché i neutrofili vengono talora prodotti in quantità adeguate in risposta a episodi infettivi.
            </li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Di solito, la neutropenia rimane asintomatica fino a quando non si sviluppa uno stato infettivo. Le manifestazioni che ne conseguono possono essere variabili, ma le più comuni sono febbre, ulcerazioni cutanee e mucose e polmoniti.
          </p>
          <p>
            Nelle forme congenite, i sintomi si manifestano solitamente a partire dal primo anno di età con febbre ricorrente, gengivite, faringo-tonsillite, sinusite, otite, ascessi e ulcere orali. In alcuni casi possono verificarsi infezioni più gravi come la sepsi (un'infezione generalizzata che può determinare un danno d'organo).
          </p>
          <p>
            Nella neutropenia ciclica, i sintomi possono variare a seconda del ciclo della conta dei neutrofili.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi viene effettuata attraverso la valutazione dell'emocromo. È importante identificare anche la causa scatenante, per poterla correggere, quando possibile. Nelle forme congenite è necessaria l'analisi genetica.
          </p>
          <p>
            Infine, nel caso della neutropenia ciclica, di fondamentale importanza è la storia clinica di infezioni periodiche e il riscontro di una conta di neutrofili inferiore a 200/mcL in almeno 3-5 giorni consecutivi, per tre cicli a intervalli di tempo regolari, in un periodo di osservazione di circa 6-8 settimane.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Il trattamento della neutropenia dipende dalla sua causa e dalla sua gravità. Nei casi lievi o moderati, spesso non è necessario alcun trattamento specifico, ma solo una buona igiene personale.
          </p>
          <p>
            Nei casi gravi, è necessario l'utilizzo di fattori di crescita emopoietici e, in alcuni casi, una profilassi antibiotica. Inoltre, in presenza di febbre o segni di infezione è importante iniziare tempestivamente una terapia antibiotica o antimicotica ad ampio spettro.
          </p>
          <p>
            Nelle forme congenite più gravi, può essere indicata l'esecuzione di un trapianto di midollo osseo, unica opzione terapeutica.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            L'andamento clinico e la prognosi della neutropenia dipendono dalla causa, dalla gravità e dalla durata della condizione. Di fondamentale importanza è inoltre la qualità e la tempestività del trattamento delle infezioni gravi.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">
              Neutropenia ciclica: RD0040<br />
              Neutropenia congenita grave: RDG051<br />
              Neutropenia cronica idiopatica grave: RDG051
            </p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Neutropenia-Ematologia, Dipartimento di Medicina Traslazionale e di Precisione Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> dott.ssa Giovanna Palumbo
            </p>
            <p className="mt-2">
              <strong>E-mail:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.orpha.net/consor/www/cgibin/OC_Exp.php?lng=IT&Expert=42738" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Orphanet - Neutropenia
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 23,
      title: "Piastrinopatie ereditarie",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            I disordini ereditari della funzione piastrinica sono patologie emorragiche ereditarie, caratterizzate da sanguinamenti muco-cutanei di entità variabile, da lieve a grave, che possono essere associati o meno a un difetto del numero delle piastrine.
          </p>
          <p>
            La loro esatta prevalenza è sconosciuta, ma è stimata oscillare tra 1/1.000.000 per le forme più rare a più di 1/100 per le forme più comuni. Si dividono in forme causate da difetti: dei recettori di proteine di adesione, dei recettori per gli agonisti solubili, dei granuli piastrinici, di trasduzione del segnale, dei fosfolipidi di membrana ed altre.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Si manifestano clinicamente con emorragie muco-cutanee: epistassi, sanguinamenti cutanei spontanei o provocati da lievi traumi, sanguinamenti eccessivi da piccole ferite, sanguinamenti del cavo orale, meno-metrorragie nelle donne, sanguinamenti eccessivi ad insorgenza immediata in seguito a estrazioni dentarie, interventi chirurgici o parto, più raramente sanguinamenti gastrointestinali, ematuria o emorragie cerebrali.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi si basa sulla clinica, l'esame emocromocitometrico, lo studio dell'aggregazione e secrezione piastrinica, lo studio delle glicoproteine di membrana piastrinica. Lo studio in biologia molecolare e/o citogenetico è necessario per la conferma diagnostica; tuttavia, nelle due più frequenti forme, la Trombastenia di Glanzmann e la Sindrome di Bernard-Soulier, lo studio molecolare, da un punto di vista clinico è soprattutto necessario per la diagnosi prenatale.
          </p>
          <p>
            Nella <strong>Trombastenia di Glanzmann</strong> il numero delle piastrine è normale, ma vi è un difetto quantitativo o qualitativo della glicoproteina di membrana piastrinica GPIIb/IIIa; questo difetto provoca una totale assenza di aggregazione piastrinica a tutti gli agonisti tranne che alla ristocetina, e anche assente o difettosa retrazione del coagulo; la diagnosi viene confermata in citoflurimetria, dimostrando l'assenza o la riduzione della GPIIb/GPIIIa.
          </p>
          <p>
            La <strong>Sindrome di Bernard-Soulier</strong> si caratterizza per trombocitopenia, presenza di piastrine giganti, assenza o marcata riduzione di aggregazione piastrinica indotta da ristocetina e normale aggregazione a tutti gli altri agonisti: la diagnosi viene confermata in citofluorimetria, dimostrando la ridotta espressione o assenza di complesso glicoproteico GPIb-V-IX.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Le opzioni per la profilassi e il trattamento sono relativamente limitate. Gli unici trattamenti curativi sono rappresentati dalla terapia genica e dal trapianto allogenico di cellule staminali ematopoietiche. In caso di sanguinamento acuto il trattamento di elezione è costituito dalle trasfusioni piastriniche.
          </p>
          <p>
            In caso di refrattarietà ai concentrati piastrinici per comparsa di allo-anticorpi, è indicato utilizzare il fattore VII attivato (rFVIIa). In alcuni casi di piastrinopatie lievi soprattutto causate da deficit di secrezione dai granuli piastrinici, può essere utilizzata la desmopressina.
          </p>
          <p>
            Gli antifibrinolitici possono essere una terapia adiuvante utile sia somministrati da soli che in associazione alle trasfusioni di piastrine, al rFVIIa o alla desmopressina.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La prognosi e la qualità di vita dipendono strettamente dal disordine specifico da cui è affetto il paziente. Alcune forme non si manifestano quasi mai clinicamente, mentre le forme più gravi quali la Tromboastenia di Glanzmann possono essere caratterizzate da eventi emorragici gravi, che possono essere trattati solo all'occorrenza, con una ridotta qualità di vita del paziente.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG030</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di Riferimento e Coordinamento Regionale per le Malattie Emorragiche (bambini e adulti) – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27a, 1° piano.
            </p>
            <p className="mt-2">
              <strong>Referenti:</strong> Dott.ssa Cristina Santoro, Dott.ssa Erminia Baldacci, Dott. Antonio Chistolini
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita per adulti e bambini scrivere a:</strong> <span className="text-accent">gruppogz@gmail.com</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="https://aiceonline.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Centri Emofilia (AICE)
                </a>
              </li>
              <li>
                <a href="https://fedemo.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Federazione delle Associazioni Emofilici (FedEmo)
                </a>
              </li>
              <li>
                <a href="https://www.fondazioneparacelso.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Fondazione Paracelso (associazione pazienti)
                </a>
              </li>
              <li>
                <a href="https://www.aelonlus.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Emofilici Lazio (AEL)
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 24,
      title: "Piastrinopenia immune primitiva cronica",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            Si parla di trombocitopenia immune (ITP) in presenza di una riduzione della conta piastrinica (piastrine &lt; 100.000/mmc) causata da una risposta autoimmune di tipo anticorpale e cellulare.
          </p>
          <p>
            Se la patologia è stata diagnosticata da meno di 3 mesi viene definita di nuova insorgenza, se negli ultimi 3-12 mesi persistente, se dura da oltre 12 mesi cronica.
          </p>
          <p>
            La trombocitopenia immune, in circa un 20% dei casi può essere secondaria ad altre patologie autoimmuni (es. Lupus Eritematoso Sistemico), ematologiche (Leucemia Linfatica Cronica) o farmaci.
          </p>
          <p>
            Può colpire sia adulti che bambini con un'incidenza annua rispettivamente di 1,6-3,9 e 6-7 casi per 100.000 persone l'anno, senza differenze di sesso in età pediatrica e più frequentemente nel sesso femminile in età adulta.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            L'ITP può essere asintomatica in 1/3 dei casi. Le manifestazioni emorragiche sono soprattutto a livello cutaneo e/o mucoso. Tali eventi si verificano principalmente in pazienti con valori di piastrine &lt; 20.000/mmc (piastrinopenia severa), ma possono anche verificarsi in caso di piastrinopenia più lieve.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi di pITP è a tutt'oggi una diagnosi di esclusione. Infatti, non esiste un marker specifico di patologia, ma, per confermare la diagnosi, è necessario escludere malattie infettive (HIV, HCV ecc.), autoimmuni (Lupus Eritematoso Sistemico, artrite reumatoide, ecc.), neoplasie, malattie linfoproliferative o altre patologie ematologiche.
          </p>
          <p>
            E' necessario eseguire in tutti i pazienti emocromo in EDTA e in citrato, uno striscio di sangue venoso periferico, l'esame obiettivo, un profilo coagulativo di base, la valutazione della funzionalità epatica e degli ormoni tiroidei, la ricerca di anticorpi per HBV-HCV-HIV, di anticorpi antifosfolipidi, antinucleo, anti-tireoperossidasi, anti-tireoglobulina, anti-TSH-R, indagini radiologiche quali eco-addome o RX torace. Altri esami, tra cui l'agoaspirato midollare, sono considerati opzionali.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            L'obiettivo della terapia è ridurre il rischio emorragico e aumentare il numero di piastrine a valori emostaticamente efficaci.
          </p>
          <p>
            Il trattamento varia tra i pazienti pediatrici e adulti, con ITP primitiva e secondaria.
          </p>
          <p>
            Nei pazienti con una forma secondaria si va ad agire sulla causa scatenante, mentre nei pazienti con una forma primitiva il trattamento è standardizzato da specifiche linee guida. Il trattamento iniziale, all'esordio, è basato su corticosteroidi e/o immunoglobuline policlonali ad alto dosaggio.
          </p>
          <p>
            Queste ultime, in particolare, sono utilizzate in caso di sintomatologia emorragica, all'esordio o meno, per ottenere una risalita rapida delle piastrine. In caso di dipendenza da corticosteroidi, per mantenere un valore di piastrine emostaticamente efficace, o di mancata risposta agli stessi, viene adottata una terapia di seconda linea. Farmaci di seconda linea sono considerati i TPO-mimetici, analoghi del fattore di crescita piastrinico, che stimolano la produzione di nuove piastrine. Inoltre farmaci da utilizzare in seconda linea o oltre, sono il fostamatinib, il rituximab e altri farmaci immunosoppressivi.
          </p>
          <p>
            Nonostante un ampio armamentario terapeutico, la splenectomia (asportazione chirurgica della milza), rappresenta ancora una valida alternativa di seconda linea o oltre in pazienti refrattari o farmacodipendenti. Solitamente viene proposta a pazienti più giovani e in buone condizioni generali per evitare lunghe medicalizzazioni.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La prognosi della patologia è buona sia in età adulta che pediatrica. Nei bambini la cronicizzazione è intorno al 20%, mentre circa l'80% dei pazienti adulti andrà incontro ad una ITP cronica. L'ITP cronica ha un impatto sulla qualità di vita soprattutto per la medicalizzazione, l'eventuale occorrenza di sanguinamenti, e problematiche psicologiche correlata alla paura della repentina riduzione delle piastrine e al sanguinamento stesso.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG031 - Ne hanno diritto solo i pazienti con forme croniche primarie</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per la Piastrinopenia Immune Cronica Primaria – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I.
            </p>
            <p className="mt-2">
              <strong>Referenti per adulti (età &gt;20 anni):</strong> Dott.ssa Cristina Santoro, Dott.ssa Erminia Baldacci, Dott. Antonio Chistolini. Via Benevento 27A, 1° piano
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">gruppogz@gmail.com</span>
            </p>
            <p className="mt-2">
              <strong>Referente per i bambini e adolescenti (età &lt;20 anni):</strong> Dott.ssa Giovanna Palumbo. Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.aipit.com/piastrinopenia-ereditaria/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Porpora Immune Trombocitopenica
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 25,
      title: "Piastrinopenie ereditarie",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            Le piastrinopenie ereditarie sono patologie rare e si stima che la loro prevalenza sia di almeno 2.7 casi ogni 100.000 abitanti. Spesso la piastrinopenia ereditaria è correlata a patologie sindromiche. Si possono classificare in base al tipo di trasmissione genetica, al meccanismo patogenetico e alle anomalie delle dimensioni delle piastrine.
          </p>
          <p>
            Da un punto di vista patogenetico si dividono in patologie con: difetto di differenziazione megacariocitaria, difetto di maturazione megacariocitaria, difetto di piastrino-formazione, ridotta sopravvivenza piastrinica. Le forme più frequenti sono quelle da difetto di maturazione megacariocitaria e di piastrino-formazione.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Le piastrinopenie ereditarie sono spesso asintomatiche e si caratterizzano per lieve riduzione della conta piastrinica, e alterazioni delle dimensioni delle piastrine. La sintomatologia, quando presente, è emorragica, con possibile comparsa di petecchie, porpora, ecchimosi, giungendo finanche all'ictus emorragico.
          </p>
          <p>
            Alcune forme si presentano nel contesto di una sindrome, come nel caso della WAS (Wiskott-Aldrich Syndrome) e della TAR (Thrombocytopenia with Absent Radius). Alcune predispongono allo sviluppo di patologie linfo-/mielo-proliferative, come la ETV6-RT, FDP-AML e la ANKRD26-RT.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi si basa su: esame obiettivo, anamnesi personale e familiare, esame emocromocitometrico in EDTA e citrato, osservazione dello striscio di sangue venoso periferico ed esecuzione di studi genetici in biologia molecolare sul probando e, quindi, sui familiari.
          </p>
          <p>
            Tali test genetici non sono ancora presenti nella pratica clinica routinaria per il loro costo e la loro scarsa influenza sulle decisioni terapeutiche, anche se si sta cercando di implementarli sempre di più. E' importante escludere anche altre possibili cause di piastrinopenia.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            Non c'è un consensus sul trattamento di tali forme. Gli unici interventi curativi sono la terapia genica e l'allotrapianto di cellule staminali ematopoietiche, quasi mai necessario, data la clinica.
          </p>
          <p>
            Alcune forme beneficiano della terapia con TPO-mimetici (Eltrombopag, Romiplostim); in alcuni casi si possono utilizzare i concentrati piastrinici; la splenectomia non è efficace, se non nelle forme con mutazione del gene WAS.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Le piastrinopenie ereditarie sono generalmente asintomatiche e non influenzano la qualità e l'aspettativa di vita del paziente. La prognosi è strettamente legata alla singola forma e alle manifestazioni cliniche. Al momento, si sta cercando di determinare con sempre maggiore precisione la prognosi di ogni forma implementando lo studio di biologia molecolare che permette una diagnosi certa del tipo di piastrinopenia ereditaria.
          </p>
          <p>
            Purtroppo, ancora spesso i pazienti con tale forma di piastrinopenia vengono diagnosticati come affetti da trombocitopenia immune e sottoposti ad inutili manovre invasive e terapie.
          </p>
          <p>
            E' importante pertanto sensibilizzare la comunità scientifica su tale problematica.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG040</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per la Piastrinopenia Immune Cronica Primaria – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I.
            </p>
            <p className="mt-2">
              <strong>Referenti per adulti (età &gt;20 anni):</strong> Dott.ssa Cristina Santoro, Dott.ssa Erminia Baldacci, Dott. Antonio Chistolini. Via Benevento 27A, 1° piano
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">gruppogz@gmail.com</span>
            </p>
            <p className="mt-2">
              <strong>Referente per i bambini e adolescenti (età &lt;20 anni):</strong> Dott.ssa Giovanna Palumbo. Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.aipit.com/piastrinopenia-ereditaria/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Italiana Porpora Immune Trombocitopenica
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 26,
      title: "Porpora trombotica trombocitopenica",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La porpora trombotica trombocitopenica (PTT o sindrome di Moschcowitz) è una malattia rara e potenzialmente fatale, caratterizzata da anemia emolitica non immune, piastrinopenia da consumo, trombosi dei piccoli vasi (microvascolare) e disfunzione d'organo, in particolare cerebrale, renale e cardiaca, su base ischemica.
          </p>
          <p>
            La causa è una riduzione dei livelli di un enzima, ADAMTS13, che in condizioni normali degrada i multimeri insolitamente grandi del fattore di von Willebrand (FvW), che promuovono l'aggregazione piastrinica con conseguente trombosi microvascolare.
          </p>
          <p>
            L'incidenza annuale è di 3.7 nuovi casi per 1.000.000 di individui, con rapporto F:M 2/1. Nel 95% dei casi la patologia è acquisita per la presenza di autoanticorpi che inibiscono l'ADAMTS13 o la rimuovono dal circolo, mentre solo nel 5% è congenita con trasmissione autosomica recessiva, causata da mutazioni del gene ADAMTS13.
          </p>
          <p>
            Nella forma congenita l'esordio clinico avviene prevalentemente, ma non esclusivamente alla nascita o nel corso dell'infanzia, mentre la forma acquisita immuno-mediata è più frequente nei giovani adulti.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            La diagnosi è complessa in considerazione della variabilità della presentazione clinica. La sintomatologia dipende dalla gravità dell'anemia, della piastrinopenia e del danno d'organo. Si possono avere:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Sintomi sistemici come nausea, vomito diarrea, astenia, pallore, ittero e urine scure</li>
            <li>Sintomatologia neurologica come confusione, afasia cefalea, deficit motori fino alle convulsioni ed al coma</li>
            <li>Sintomatologia emorragica come epistassi, gengivorragia, metrorragia, ecchimosi, petecchie</li>
            <li>Sintomatologia cardiaca come aritmie, infarto fino alla morte improvvisa</li>
          </ul>
          <p>Le alterazioni della funzionalità renale sono più rare.</p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La diagnosi di PTT si basa sulla presenza di anemia emolitica non immune, con incremento degli indici di emolisi (reticolociti, LDH, bilirubina, aptoglobina ridotta) e piastrinopenia. Lo striscio di sangue venoso periferico mostra un incremento degli schistociti (&gt; 1%), frammenti di globuli rossi di forma variabile.
          </p>
          <p>
            La diagnosi viene poi confermata con il dosaggio dell'attività di ADAMTS13 che deve essere &lt;10% e dalla ricerca di anticorpi inibitori. Molto utile nel sospetto clinico è l'impiego degli SCORES come il Plasmic score che predicono la probabilità di un'attività di ADAMTS13&lt;10%, ma non sostituiscono il dosaggio dell'attività della metalloproteasi.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            La terapia va iniziata immediatamente sulla base del solo sospetto clinico. Nella PTT acquisita, immuno-mediata, si utilizza una combinazione di plasma-exchange, che consiste nella sostituzione del plasma del paziente con quello del donatore e che deve essere iniziata con urgenza, associata a terapia cortisonica.
          </p>
          <p>
            Tale combinazione ha lo scopo di ripristinare livelli sufficienti di ADAMTS13, di rimuovere gli autoanticorpi e i multimeri insolitamente grandi del FvW e di sopprimere la deregolata risposta autoimmune.
          </p>
          <p>
            Negli adulti e adolescenti di età maggiore di 12 anni, in aggiunta alla PEX e steroidi si utilizza il Caplacizumab, un nano-anticorpo che inibisce l'interazione tra i multimeri insolitamente grandi del FvW e le piastrine, prevenendo la trombosi microvascolare, riducendo così la mortalità nella fase acuta.
          </p>
          <p>
            Nella malattia refrattaria o in caso di recidiva si utilizza il Rituximab, anticorpo monoclonale anti CD20, per potenziare l'immunosoppressione.
          </p>
          <p>
            Nella PTT congenita è indicata la sola infusione di plasma con lo scopo di somministrare l'enzima carente, in attesa della disponibilità in commercio l'ADAMTS13 ricombinante.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La malattia ha una mortalità che supera il 90% se non riconosciuta e prontamente trattata. Nella forma immuno-mediata le recidive si verificano nel 30-35% dei pazienti soprattutto nel primo anno e circa un terzo dei pazienti presenta una forma cronica pluri-recidivante, che richiede terapia immunosoppressiva cronica.
          </p>
          <p>
            Anche la forma congenita tende a recidivare soprattutto in seguito ad episodi infettivi o alla gravidanza e richiede periodiche infusioni di plasma.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RGG010</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per la Porpora Trombotica Trombocitopenica – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27A, III piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> Dott.ssa Silvia Trisolini
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita (adulti):</strong> telefonare allo 0649974431 dalle 9 alle 13:00, dal lunedì al venerdì.
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="https://www.anptt.org/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Nazionale Porpora Trombotica Trombocitopenica (ANPTT) Onlus
                </a>
              </li>
              <li>
                <a href="https://www.osservatoriomalattierare.it/malattie-rare/porpora-trombotica-trombocitopenica" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Porpora trombotica trombocitopenica acquisita: linee guida dalla Società Italiana di Ematologia – Osservatorio Malattie Rare
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 27,
      title: "Sferocitosi ereditaria",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La sferocitosi ereditaria (HS) è la più frequente patologia di membrana del globulo rosso (GR) e la maggior causa di anemia emolitica congenita in Europa, con una prevalenza tra 1:1600 e 1:2000. La trasmissione della malattia è autosomica dominante in circa il 75% dei casi, nel restante 25% può essere autosomica recessiva o comparire de novo.
          </p>
          <p>
            Le mutazioni interessano i geni che producono le proteine della membrana del GR, che sono importanti nel rendere deformabili i GR; una loro alterazione causa la perdita di elasticità della membrana e la trasformazione della forma a disco biconcavo del GR a una forma sferica (sferocita). Gli sferociti quando attraversano i piccoli vasi della milza (sinusoidi splenici) rimangono intrappolati e, successivamente, distrutti dai macrofagi (cellule spazzino) con la conseguente insorgenza di emolisi (anemia e ittero).
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Il quadro clinico e l'età d'esordio sono variabili. Le manifestazioni cliniche possono essere assenti, lievi (modesta anemia emolitica con subittero e/o ittero lieve) e gravi (crisi emolitiche acute), con ittero (colorazione giallastra di cute e mucose). In caso di esordio neonatale, vi è una persistenza dell'ittero neonatale. Si distinguiamo 4 forme cliniche, in base ai valori dell'emoglobina e dei reticolociti: lieve, moderata, moderatamente grave e grave.
          </p>
          <p>
            Durante l'infanzia si possono verificare, nel corso di infezioni virali (Parvovirus B19 o EBV) delle crisi aplastiche, caratterizzate da ridotta produzione nel midollo osseo di globuli rossi, globuli bianchi e piastrine. La splenomegalia può essere di entità variabile. Una frequente complicanza è rappresentata dalla calcolosi biliare della colecisti, secondaria all'emolisi cronica.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            La HS deve essere sospettata in bambini con familiarità per la malattia, e nei casi di anemia cronica non sideropenica o dalla precoce insorgenza di splenomegalia e/o litiasi biliare.
          </p>
          <p>
            Gli esami ematochimici mostrano un aumento dei reticolociti e della bilirubina prevalentemente indiretta; frequente è, inoltre, la presenza di sferociti all'osservazione al microscopio dello striscio del sangue venoso periferico.
          </p>
          <p>
            Per la diagnosi si impiegano alcuni test mirati a identificare un'aumentata fragilità osmotica dei GR ed elettroforesi delle proteine di membrana del GR che permette di identificare la proteina di membrana responsabile della malattia.
          </p>
          <p>
            Il test genetico di II livello è utile nelle forme con pochi sintomi, e per l'indicazione alla splenectomia e/o a scopo di ricerca.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            I pazienti affetti da HS devono essere sottoposti a periodici controlli clinici, ematochimici, ecografia dell'addome per evidenziare eventuale splenomegalia e calcolosi della colecisti.
          </p>
          <p>
            Nelle crisi emolitiche gravi è necessario eseguire trasfusioni di GR, soprattutto durante la prima infanzia.
          </p>
          <p>
            L'unica terapia risolutiva è la splenectomia (asportazione chirurgica della milza) che comporta un aumentato rischio infettivo. Va riservata ai casi più gravi e deve essere eseguita possibilmente dopo i sei anni di vita, per attendere lo sviluppo di una migliore competenza del sistema immunitario. La splenectomia viene preceduta da vaccinazioni contro le infezioni da batteri capsulati (Streptococcus Pneumoniae, Neisseria Meningitidis, Haemophilus Influenzae B) e seguita da una profilassi antibiotica per almeno due anni.
          </p>
          <p>
            La terapia prevede la somministrazione di acido folico per l'aumentato fabbisogno.
          </p>
          <p>
            La colecistectomia va riservata ai casi di calcolosi sintomatica.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La prognosi della malattia è variabile e dipende dalla gravità della forma di HS e dalle complicanze. In genere l'aspettativa di vita è simile a quella di soggetti non affetti.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG010</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Anemie ereditarie – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 6, Accettazione-ambulatorio pediatrico 1° piano.
            </p>
            <p className="mt-2">
              <strong>Medico Referente:</strong> dott.ssa Michela Ribersani
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita:</strong> 0649974737-735-731 (lun-ven 14,30-15,30)
            </p>
            <p className="mt-2">
              <strong>E-mail:</strong> <span className="text-accent">rare.ematologiapediatrica@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2">
              <li>
                <a href="https://www.orpha.net/consor/cgi-bin/OC_Exp.php?lng=IT&Expert=822" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Orphanet - Sferocitosi ereditaria
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 28,
      title: "Sindrome mieloidisplastiche",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            Le sindromi mieloidisplastiche sono patologie che si manifestano tipicamente nell'età avanzata; l'età media alla diagnosi si aggira intorno ai 70 anni. In Italia, l'incidenza è di circa 4-5 casi ogni 100000 soggetti l'anno. Si tratta di patologie in cui si ha la perdita della capacità di normale maturazione delle cellule della linea mieloide, eritroide e magacariocitaria (precursori di globuli rossi, neutrofili, piastrine), con conseguente riduzione delle cellule mature circolanti. La causa della patologia, nella maggior parte dei casi, è ancora sconosciuta. Esistono tuttavia alcune forme, dette secondarie, la cui insorgenza viene messa in relazione alla pregressa esposizione a sostanze tossiche come benzene, piombo, solventi, o a chemioterapici. Il rischio di progressione in leucemia mieloide acuta (LMA) è variabile.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            I sintomi sono principalmente legati alla riduzione dei globuli rossi, globuli bianchi e piastrine, con conseguente:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Anemia: pallore, astenia, affaticamento, tachicardia, palpitazioni</li>
            <li>Neutropenia: infezioni e febbre</li>
            <li>Piastrinopenia: sanguinamenti della cute e mucose</li>
          </ul>
          <p>
            Inoltre, possono essere presenti aumento del volume del fegato e della milza (epatosplenomegalia), come conseguenza dell'attivazione dell'emopoiesi extramidollare di tipo compensatorio.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            Dopo aver escluso le altre possibili cause di citopenia, la diagnosi viene effettuata sulla base del sospetto clinico (età avanzata e presenza di citopenia) attraverso lo studio morfologico, citogenetico e di biologia molecolare del midollo osseo.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            La terapia dipende dal rischio di progressione in leucemia acuta, dall'età e dalle condizioni generali del paziente. Per questo, sono state sviluppate scale di valutazione che suddividono i pazienti in fasce di rischio, che tengono conto di parametri clinici e biologici (classificazione R-IPSS- Revised Prognostic Scoring System). Nei pazienti a basso rischio, il trattamento della malattia consiste nell'utilizzo di una terapia di supporto con emotrasfusioni, terapia ferro-chelante, fattori di crescita (G-CSF, eritropoietina, TPO ricombinanti), antibioticoterapia. Per i pazienti con una malattia a rischio maggiore di evoluzione in leucemia acuta, sono disponibili diverse strategie: chemioterapia intensiva, agenti ipometilanti, farmaci immunosoppressori. L'unico trattamento curativo è il trapianto allogenico di cellule staminali riservato a pazienti con età inferiore a 65-70 anni, con mielodisplasia a rischio medio-alto, con assenza di significative comorbidità, e, in presenza di un donatore compatibile. Nuovi farmaci, attualmente disponibili, si sono dimostrati efficaci in alcune categorie di pazienti. Tra questi, l'azacitidina, la decitabina, utilizzate in tutti i tipi di mielodisplasia, sono efficaci nel ridurre i sintomi e ritardare la progressione in leucemia acuta; la lenalidomide, invece, si è dimostrata efficace nei pazienti con sindrome del 5q-, una forma di mielodisplasia in cui è deleto (mancante) il braccio lungo del cromosoma 5.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            La rapidità di evoluzione della malattia è in rapporto alla categoria di rischio del paziente. La classificazione R-IPSS, suddivide i pazienti in base all'entità delle citopenie, le alterazioni citogenetiche e il numero di cellule patologiche a livello midollare. Negli ultimi anni, un altro fattore di rischio è rappresentato dalla presenza di mutazioni di alcuni geni.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">Codice esenzione</h4>
            <p className="text-accent font-medium">RDG050</p>

            <h4 className="font-semibold mt-3">A chi rivolgersi</h4>
            <p>
              Centro di riferimento regionale per le Mielodisplasie – Ematologia, Dipartimento di Medicina Traslazionale e di Precisione, Università Sapienza, AOU Policlinico Umberto I, Via Benevento 27A, terzo piano.
            </p>
            <p className="mt-2">
              <strong>Medico di riferimento:</strong> Prof. Massimo Breccia
            </p>
            <p className="mt-2">
              <strong>Per prenotare una prima visita, telefonare allo</strong> 0649974-435/-437/-440, dalle 12:00 alle 13:00, dal lunedì al venerdì.
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="https://www.ail.it/patologie-e-terapie/patologie-ematologiche/leucemia/572-sindromi-mielodisplastiche" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  AIL: Sindromi mielodisplastiche
                </a>
              </li>
              <li>
                <a href="https://www.mds-foundation.org/for-healthcare-professionals/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  MDS Foundation
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 29,
      title: "Talassemia",
      modalContent: (
        <div className="space-y-4">
          <h3 className="text-lg font-bold text-primary">Che cosa è</h3>
          <p>
            La talassemia è un disordine ereditario caratterizzato da un difetto nella sintesi dell'emoglobina.
          </p>
          <p>
            La molecola di emoglobina dell'adulto è normalmente formata da due coppie di catene, alfa e beta (emoglobina A). Nella talassemia si assiste ad una sbilanciata sintesi delle catene di emoglobina, per cui possiamo identificare una talassemia alfa (α-talassemia) e una talassemia beta (β-talassemia). L' α-talassemia è caratterizzata da una ridotta produzione di catene alfa, causata dalla delezione (mancanza) di uno o più geni alfa globinici. Poiché l'uomo possiede quattro geni (alleli) alfa, è possibile che la delezione possa coinvolgere: un solo allele (forma asintomatica), due alleli (tratto talassemico), tre alleli (forma moderata-grave di anemia emolitica, definita malattia da emoglobina H, HbH), o di tutti e quattro gli alleli (condizione incompatibile con la vita, definita idrope fetale).
          </p>
          <p>
            La β-talassemia è dovuta ad una ridotta o assente produzione delle catene beta, per mutazione del gene della beta globina. Nel caso in cui un solo gene sia mutato, si parla di β-talassemia minor o tratto talassemico (asintomatica). Quando, invece, sono mutati entrambi i geni si ha la β-talassemia major, che è caratterizzata anemia emolitica grave.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Sintomi</h3>
          <p>
            Tutte le forme di talassemia presentano sintomi simili, ma di gravità variabile. Nell' α-talassemia con tratto talassemico e nella β-talassemia minor, i soggetti presentano lieve anemia asintomatica.
          </p>
          <p>
            L'anemia è il segno caratteristico della talassemia, sia alfa che beta, e si manifesta con pallore, stanchezza, debolezza e dispnea da sforzo. Altro segno caratteristico è l'ittero dovuto all'emolisi cronica che può determinare anche una calcolosi della colecisti. Nel corso della malattia, si verifica un aumento delle dimensioni della milza, deformità ossee negli adulti, soprattutto a livello del cranio, e ritardo della crescita e dello sviluppo nei bambini. Dal momento che i pazienti ricevono numerose trasfusioni di sangue, si verifica un sovraccarico di ferro che si accumula e si deposita in diversi organi, tra cui il cuore, causando una progressiva sofferenza cardiaca fino all' insufficienza.
          </p>

          <h3 className="text-lg font-bold text-primary mt-6">Diagnosi</h3>
          <p>
            Le forme più gravi di talassemia vengono generalmente diagnosticate entro i due anni di vita.
          </p>
          <p>
            Le indagini indispensabili per diagnosticare la talassemia sono:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Emocromo, che mostra anemia (riduzione di emoglobina) e un numero elevato di globuli rossi che sono di volume più piccolo;</li>
            <li>Elettroforesi dell'emoglobina, che è indispensabile per determinare i tipi e le quantità di emoglobina presenti nel sangue;</li>
            <li>Test genetici, che è utile per caratterizzare le specifiche mutazioni dei geni coinvolti.</li>
            <li>Test prenatale: per verificare la presenza di talassemia nel feto prima della nascita, se uno o entrambi i genitori sono affetti o portatori di talassemia. La diagnosi prenatale può essere fatta con il prelievo di villi coriali, l'amniocentesi o il prelievo di sangue fetale.</li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Terapia</h3>
          <p>
            La terapia per la talassemia dipende dal tipo e dalla severità della malattia:
          </p>
          <ul className="list-disc pl-5 space-y-1">
            <li>Nei pazienti con tratto α-talassemico o β-talassemia, non è necessario nessun trattamento.</li>
            <li>Trasfusioni di emazie, la cui cadenza dipende dalla forma di talassemia: ogni 15-30 giorni per le forme più gravi, occasionali per quella che in passato era definita forma intermedia.</li>
            <li>Terapia ferrochelante, necessaria per i pazienti trasfusione dipendente, per ridurre l'eccesso di ferro accumulato nei tessuti.</li>
            <li>Splenectomia (rimozione chirurgica della milza) è un'opzione terapeutica in caso di importante aumento di volume della milza con aggravamento dell'anemia.</li>
            <li>Nuovi farmaci in grado di ridurre il fabbisogno trasfusionale nei pazienti con β-talassemia.</li>
            <li>Trapianto allogenico di cellule staminali emopoietiche da donatore compatibile e la terapia genica sono le possibili terapie risolutive.</li>
          </ul>

          <h3 className="text-lg font-bold text-primary mt-6">Prognosi</h3>
          <p>
            Le talassemie si dividono fondamentalmente in trasfusione dipendenti e trasfusione indipendenti.
          </p>
          <p>
            L'andamento clinico e la prognosi della talassemia variano a seconda della forma e del trattamento. Le forme minori di talassemia possono essere asintomatiche o causare solo lieve anemia, mentre le forme maggiori possono provocare gravi problemi. Una diagnosi precoce permette un intervento tempestivo, in modo da limitare le complicanze e migliorare la qualità di vita del paziente che è nettamente migliorata negli ultimi anni così come l'aspettativa di vita.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
            <h4 className="font-semibold">A chi rivolgersi</h4>
            <p>
              Centro di Riferimento Regionale per la diagnosi e il trattamento delle Talassemie. U.O.C. Immunoematologia e Medicina Trasfusionale, AOU Policlinico Umberto I.
            </p>
            <p className="mt-2">
              Via Chieti, 7.
            </p>
            <p className="mt-2">
              <strong>Medici di riferimento:</strong> dott.ssa Pellegrina Pugliese, dott.ssa Anna Annunziata Losardo, dott. Marco Marziali, dott.ssa Michela Ribersani.
            </p>
            <p className="mt-2">
              <strong>Tel.</strong> 0649976550/0649976533
            </p>
            <p className="mt-1">
              <strong>E-mail:</strong> <span className="text-accent">talassemia@policlinicoumberto1.it</span>
            </p>
          </div>

          <div className="mt-6">
            <h4 className="font-semibold">Per saperne di più</h4>
            <ul className="mt-2 space-y-2">
              <li>
                <a href="https://www.goccedivita.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                  Associazione Gocce di vita per la Talassemia
                </a>
                <p className="ml-2">Email: info@goccedivita.it / soci@goccedivita.it</p>
              </li>
              <li>
                <span className="text-accent">AMITAL, Associazione Microcitemici e Talassemici del Lazio</span>
                <p className="ml-2">Email: amitalmail@libero.it</p>
              </li>
            </ul>
          </div>
        </div>
      )
    }
  ];

  const [openModalId, setOpenModalId] = useState(null);
  const [isNovitaModalOpen, setIsNovitaModalOpen] = useState(false);
  const [isPicnocitosExpanded, setIsPicnocitosExpanded] = useState(false);
  // Sezioni informative aperte tramite pulsante: 'normative' | 'aou' | 'ern' | 'eventi'
  const [openSectionModal, setOpenSectionModal] = useState(null);
  const location = useLocation();

  // Apertura automatica modale da parametro URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const malattiaSlug = params.get('malattia');
    
    if (malattiaSlug) {
      // Mappa degli slug alle malattie
      const diseaseSlugMap = {
        'porpora-trombotica-trombocitopenica': 26
      };
      
      const diseaseId = diseaseSlugMap[malattiaSlug];
      if (diseaseId) {
        setOpenModalId(diseaseId);
      }
    }
  }, [location.search]);

  const openModal = (id) => {
    setOpenModalId(id);
  };

  const closeModal = () => {
    setOpenModalId(null);
  };
  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary/80">
        <div className="container mx-auto px-4 py-16 md:py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Malattie Rare di Interesse Ematologico</h1>
            <p className="text-xl text-white md:w-3/4 mx-auto">
              Informazioni, risorse e supporto per i pazienti con malattie rare di interesse ematologico
            </p>
            <div className="text-lg text-white md:w-3/4 mx-auto mt-4">
              <div className="flex justify-center">
                <button
                  onClick={() => setIsNovitaModalOpen(true)}
                  className="px-6 py-3 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors duration-200"
                >
                  NOVITÀ SULLE MALATTIE RARE EMATOLOGICHE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Introduction Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b pb-2">
            <span className="bg-gradient-to-r from-accent to-accent bg-clip-text text-transparent">
              Introduzione alle Malattie Rare di Interesse Ematologico
            </span>
          </h2>
          <div className="space-y-4 text-gray-700">
            <p>
              Sono definite malattie rare le patologie con una frequenza nella popolazione inferiore a 5 affetti ogni 10.000 abitanti. Le malattie rare sono un gruppo eterogeneo che rappresentano, complessivamente, circa il 10% di tutte le patologie. La maggior parte delle malattie rare sono genetiche, ma possono essere anche acquisite; quindi, possono manifestarsi sin dalla nascita, ma anche in età adulta o avanzata.
            </p>
            <p>
              Finora sono state identificate tra le 6.000 e le 8.000 malattie rare, molto diverse tra loro ma che condividono alcune problematiche, quali una difficoltà nella diagnosi, una complessità clinica, un'evoluzione progressiva, una mancanza di una terapia specifica che, quando disponibile, è molto costosa, un andamento, nella maggior parte dei casi invalidante e un impegnativo coinvolgimento dei familiari (care givers).
            </p>
            <p>
              Inoltre, la loro gestione richiede un approccio multidisciplinare, che prevede un articolato e complesso sistema comprendente diversi specialisti con competenze specifiche ed expertise, e un supporto infermieristico, riabilitativo e socioassistenziali.
            </p>
            <p>
              Nel sospetto o dopo la diagnosi è importante indirizzare immediatamente il paziente ad un centro specializzato per la cura e la gestione della patologia, per evitare un ritardo diagnostico e/o di trattamento.
            </p>
            <p>
              In Italia, secondo Orphanet Italia, i malati rari sono circa 2 milioni.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 my-8 max-w-4xl mx-auto">
              <button
                onClick={() => {
                  const section = document.getElementById('malattie-rare-ematologiche');
                  if (section) {
                    section.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                className="px-6 py-4 text-lg bg-accent text-white font-medium rounded-lg hover:bg-accent/90 transition-colors duration-200 flex items-center justify-center text-center"
              >
                MALATTIE RARE DI INTERESSE EMATOLOGICO <HiArrowRight className="ml-2 flex-shrink-0" />
              </button>
              <button
                onClick={() => setIsNovitaModalOpen(true)}
                className="px-6 py-4 text-lg bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors duration-200 flex items-center justify-center text-center"
              >
                NOVITÀ SULLE MALATTIE RARE EMATOLOGICHE
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Approfondimenti - sezioni informative e istituzionali accessibili tramite pulsante */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b pb-2">
            <span className="bg-gradient-to-r from-accent to-accent bg-clip-text text-transparent">
              Approfondimenti
            </span>
          </h2>
          <p className="mb-6 text-gray-700">
            Clicca su uno dei pulsanti per consultare i relativi contenuti.
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4">
            <button
              onClick={() => setOpenSectionModal('normative')}
              className="px-6 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors duration-200 text-center"
            >
              Normative e Regolamentazioni
            </button>
            <button
              onClick={() => setOpenSectionModal('aou')}
              className="px-6 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors duration-200 text-center"
            >
              AOU Policlinico Umberto I e Malattie Rare
            </button>
            <button
              onClick={() => setOpenSectionModal('ern')}
              className="px-6 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-colors duration-200 text-center"
            >
              ERN EuroBloodNet
            </button>
            <button
              onClick={() => setOpenSectionModal('eventi')}
              className="px-6 py-4 bg-blue-700 text-white font-semibold rounded-lg hover:bg-blue-800 transition-colors duration-200 text-center"
            >
              EVENTI ISTITUZIONALI SULLE MALATTIE RARE
            </button>
          </div>
        </div>
      </section>

      {/* New Informative Box for Email */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="p-6 bg-blue-50 border border-blue-200 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold text-primary mb-3">Hai domande sulle malattie rare?</h3>
            <p className="text-gray-700">
              Per ricevere chiarimenti o supporto su tematiche legate alle malattie rare, puoi contattare l’associazione scrivendo all’indirizzo email:
              <a href="mailto:quesitirare.robinhoodromaodv@gmail.com" className="text-accent hover:underline font-medium">
                quesitirare.robinhoodromaodv@gmail.com
              </a>
            </p>
          </div>
        </div>
      </section>

      {/* Malattie Rare di Interesse Ematologico Section */}
      <section className="py-12 bg-white" id="malattie-rare-ematologiche">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-6 text-gray-800 border-b pb-2">
            <span className="bg-gradient-to-r from-accent to-accent bg-clip-text text-transparent">
              Malattie Rare di Interesse Ematologico
            </span>
          </h2>

          <p className="mb-8 text-gray-700">
            Di seguito è presentata una selezione di malattie rare di interesse ematologico.
            Clicca su "Leggi di più" per ottenere maggiori informazioni su ciascuna patologia.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
            {diseases.map((disease) => (
              <div key={disease.id} className="bg-white rounded-lg shadow-md border border-gray-200 overflow-hidden transition-transform duration-300 hover:shadow-lg hover:-translate-y-1">
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-800 mb-3">{disease.title}</h3>
                  <button
                    onClick={() => openModal(disease.id)}
                    className="mt-4 flex items-center text-accent hover:text-accent/90 font-medium transition-colors duration-200"
                  >
                    Leggi di più <HiArrowRight className="ml-2" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {openModalId && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-[80%] mx-auto overflow-hidden flex flex-col max-h-[80vh]">
            <div className="px-6 py-4 bg-primary text-white flex justify-between items-center">
              <h3 className="text-xl font-semibold">
                {diseases.find(d => d.id === openModalId)?.title}
              </h3>
              <button
                onClick={closeModal}
                className="text-white hover:text-gray-200 focus:outline-none"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1">
              {(() => {
                const disease = diseases.find(d => d.id === openModalId);
                if (!disease) return null;

                // Check if modalContent is a string or JSX
                if (typeof disease.modalContent === 'string') {
                  return <p className="text-gray-700">{disease.modalContent}</p>;
                } else {
                  // It's JSX content, render it directly
                  return disease.modalContent;
                }
              })()}
            </div>
            <div className="p-4 bg-gray-50 border-t flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-accent text-white font-medium rounded-lg hover:bg-accent/90 transition-colors duration-200"
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Novita Modal */}
      {isNovitaModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-auto overflow-hidden flex flex-col max-h-[80vh]">
            <div className="px-6 py-4 bg-red-600 text-white flex justify-between items-center">
              <h3 className="text-xl font-semibold">
                NOVITÀ SULLE MALATTIE RARE EMATOLOGICHE
              </h3>
              <button
                onClick={() => {
                  setIsNovitaModalOpen(false);
                  setIsPicnocitosExpanded(false);
                }}
                className="text-white hover:text-gray-200 focus:outline-none"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1">
              <div className="space-y-6">
                <div className="border-b border-gray-200 pb-6">
                  <h3 className="text-2xl font-bold text-primary mb-4">
                    CHE COSA È LA PICNOCITOSI? E PERCHÉ DESIDERO PARLARNE?
                  </h3>

                  <p className="text-sm text-gray-600 font-semibold mb-4">
                    Dott.ssa Anna Maria Testi
                  </p>

                  <div className="space-y-4 text-gray-700">
                    <p>
                      Anche in questo caso siamo di fronte ad una malattia rara e, non solo per incidenza, ma anche perché non sempre riconosciuta e diagnosticata.
                    </p>
                    <p>
                      Questa malattia insorge nel neonato, intorno alla seconda settimana di vita, ed è caratterizzata dalla presenza di globuli rossi anomali detti picnociti. La patologia non è trasmessa dai genitori, ma per cause non ancora ben conosciute, i globuli rossi del neonato perdono la loro forma originale e diventano contratti, più densi e presentano una superficie spinosa. Purtroppo muoiono più rapidamente{!isPicnocitosExpanded && (
                        <>
                          ...{' '}
                          <button
                            onClick={() => setIsPicnocitosExpanded(true)}
                            className="text-primary font-medium hover:text-primary/80 transition-colors"
                          >
                            Leggi di più
                          </button>
                        </>
                      )}
                      {isPicnocitosExpanded && (
                        <> dei globuli rossi normali, causando aumento della bilirubina e anemia, a volte grave. Pensate che la malattia è stata descritta per la prima volta dal prof. Tuffy nel 1959 e, da allora non sono stati fatti grandi progressi per consentirci di capire come evitare il verificarsi di questo evento. Abbiamo però imparato a gestirla con l'impiego della fototerapia, exsanguinotrasfusioni per mantenere i livelli di bilirubina entro limiti di sicurezza e trasfusioni di globuli rossi concentrati per correggere l'anemia. In rari casi, anche dopo l'intenso trattamento, i picnociti rimangono; sono stati allora utilizzati alcuni farmaci, quali l'eritropoietina, per stimolare la produzione di globuli rossi sani.</>
                      )}
                    </p>
                    {isPicnocitosExpanded && (
                      <>
                        <p>
                          Come si fa la diagnosi di questa malattia ? E' molto semplice, ma bisogna pensarci. Si striscia su un vetrino una goccia di sangue del neonato, si effettua la normale colorazione e, al microscopio ottico è possibile osservare i picnociti. Al momento, non sono necessari altri tests, come quello genetico che comportano ulteriore prelievo di sangue al piccolo paziente.
                        </p>
                        <p>
                          Desidero quindi rivolgermi ai neonatologi, pediatri ematologi per ricordare che questa malattia esiste e bisogna pensarci tutte le volte che si osserva anemia e aumento della bilirubina nel neonato, per poter iniziare il prima possibile il trattamento.
                        </p>
                      </>
                    )}
                  </div>
                </div>
                <div className="border-b border-gray-200 pb-6">
                  <h3 className="text-2xl font-bold text-primary mb-4">
                    MALATTIA DI GAUCHER, GAMMOPATIE E MIELOMA MULTIPLO
                  </h3>

                  <p className="text-sm text-gray-600 font-semibold mb-4">
                    DOTT.SSA FIORINA GIONA
                  </p>

                  <div className="space-y-4 text-gray-700">
                    <p>
                      Diversi studi hanno riportato un aumento della prevalenza di gammopatie, ovvero la
                      produzione anomala di proteine, e di mieloma multiplo (MM) nei pazienti affetti da malattia
                      di Gaucher. Recentemente, studi su ampie casistiche hanno contribuito
                      all'approfondimento delle conoscenze sull'associazione tra la malattia di Gaucher, le
                      gammopatie, sia monoclonali che policlonali, e il mieloma multiplo.
                    </p>

                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                      <p className="font-semibold text-primary mb-2">
                        Per saperne di più...
                      </p>
                      <a
                        href="https://www.ematologiainprogress.it/focus-on-malattia-di-gaucher-associata-a-gammopatia-monoclonale-di-incerto-significato-mgus-e-mieloma-multiplo/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-accent hover:text-accent/90 hover:underline font-medium break-words"
                      >
                        https://www.ematologiainprogress.it/focus-on-malattia-di-gaucher-associata-a-gammopatia-monoclonale-di-incerto-significato-mgus-e-mieloma-multiplo/
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4 bg-gray-50 border-t flex justify-end">
              <button
                onClick={() => {
                  setIsNovitaModalOpen(false);
                  setIsPicnocitosExpanded(false);
                }}
                className="px-4 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700 transition-colors duration-200"
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modali sezioni informative ed eventi istituzionali */}
      {openSectionModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-[80%] mx-auto overflow-hidden flex flex-col max-h-[85vh]">
            <div className={`px-6 py-4 ${openSectionModal === 'eventi' ? 'bg-blue-700' : 'bg-primary'} text-white flex justify-between items-center`}>
              <h3 className="text-xl font-semibold pr-4">
                {openSectionModal === 'normative' && 'Normative e Regolamentazioni'}
                {openSectionModal === 'aou' && 'AOU Policlinico Umberto I e Malattie Rare'}
                {openSectionModal === 'ern' && 'ERN EuroBloodNet'}
                {openSectionModal === 'eventi' && 'Eventi istituzionali sulle Malattie Rare'}
              </h3>
              <button
                onClick={() => setOpenSectionModal(null)}
                className="text-white hover:text-gray-200 focus:outline-none flex-shrink-0"
                aria-label="Chiudi"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
            <div className="p-6 overflow-y-auto flex-1">
              {openSectionModal === 'normative' && (
                <div className="space-y-4 text-gray-700">
                  <p>
                    Nel 2001, è stato pubblicato dal Ministero della Salute un primo elenco di malattie rare che hanno diritto all'esenzione dal ticket (DM 279/2001) e che è stato ampliato con il DPCM del 12 gennaio 2017.
                  </p>
                  <div className="mt-6 mb-6">
                    <h3 className="text-xl font-semibold mb-3 text-gray-800">Risorse Ufficiali</h3>
                    <ul className="space-y-3 list-disc pl-6">
                      <li>
                        Per conoscere l'elenco delle malattie rare, consultare il{" "}
                        <a href="https://www.malattierare.gov.it/" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 hover:underline transition-colors duration-200">
                          sito del Ministero della Salute – Istituto Superiore di Sanità
                        </a>
                      </li>
                      <li>
                        Per l'esenzione dal ticket consultare la{" "}
                        <a href="https://www.malattierare.gov.it/esenzioni" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 hover:underline transition-colors duration-200">
                          pagina del Ministero della Salute – Istituto Superiore di Sanità dedicata alle esenzioni
                        </a>
                      </li>
                    </ul>
                  </div>
                  <p>
                    Nell'ambito della propria autonomia, ogni regione ha stabilito il piano per le malattie rare.
                  </p>
                  <div className="mt-4 p-4 bg-primary/5 rounded-lg border border-primary/10">
                    <p className="font-medium text-primary">
                      Per saperne di più su quello della Regione Lazio, visitare il{" "}
                      <a href="https://www.salutelazio.it/malattie-rare-lazio" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 font-bold hover:underline transition-colors duration-200">
                        sito ufficiale della Regione Lazio
                      </a>
                    </p>
                  </div>
                </div>
              )}

              {openSectionModal === 'aou' && (
                <div className="space-y-4 text-gray-700">
                  <p>
                    L'AOU Policlinico Umberto, che ha al suo interno 16 Centri riconosciuti dalla Regione Lazio, per un efficace coordinamento e gestione dell'attività clinica e di ricerca ha istituito il Centro Interdipartimentale Malattie Rare (CIMR);
                  </p>
                  <p>
                    <a href="https://www.policlinicoumberto1.it/home-page/presidi-e-centri-di-eccellenza/malattie-rare/" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 hover:underline transition-colors duration-200 break-words">
                      https://www.policlinicoumberto1.it/home-page/presidi-e-centri-di-eccellenza/malattie-rare/
                    </a>
                  </p>
                  <p>
                    All'interno dell'AOU Policlinico Umberto I, l'Ematologia (
                    <a href="https://www.policlinicoumberto1.it/unita/ematologia/" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 hover:underline transition-colors duration-200 break-words">
                      https://www.policlinicoumberto1.it/unita/ematologia/
                    </a>
                    )
                    è Centro di Riferimento regionale per 30 patologie di interesse ematologico, neoplastiche e non, compresi i disturbi della coagulazione. Inoltre, partecipa, sin dall'istituzione degli ERN nel 2017 (
                    <a href="https://health.ec.europa.eu/european-reference-networks/overview/it" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 hover:underline transition-colors duration-200 break-words">
                      https://health.ec.europa.eu/european-reference-networks/overview/it
                    </a>
                    ), all'ERN EuroBloodNet (
                    <a href="https://eurobloodnet.eu/ern-eurobloodnet/" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 hover:underline transition-colors duration-200 break-words">
                      https://eurobloodnet.eu/ern-eurobloodnet/
                    </a>
                    ).
                  </p>
                  <p>
                    L'Unione Europea, con l'obiettivo di agevolare l'accesso ad un'assistenza sanitaria transfrontaliera sicura e di qualità e di promuove la cooperazione tra gli Stati membri in materia di assistenza sanitaria per i malati affetti da patologie rare, nel pieno rispetto delle competenze nazionali, ha emanato una direttiva (Direttiva europea 2011/24/UE), nell'ambito della quale sono state attivate 24 reti di riferimento europee, European Rare Network (ERN), ognuna delle quali lavora su specifiche aree di competenza.
                  </p>
                </div>
              )}

              {openSectionModal === 'ern' && (
                <div className="space-y-4 text-gray-700">
                  <p>
                    L'<strong>EuroBloodNet</strong> (formalmente <strong>ERN-EuroBloodNet</strong>) (
                    <a href="https://eurobloodnet.eu/" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 hover:underline transition-colors duration-200 break-words">
                      https://eurobloodnet.eu/
                    </a>
                    ) è la <strong>Rete Europea di Riferimento per le malattie ematologiche rare</strong>, istituita dall'Unione Europea nell'ambito delle <strong>European Reference Networks (ERNs)</strong>. Il suo scopo è mettere in collegamento centri ospedalieri altamente specializzati, medici, ricercatori e associazioni di pazienti per migliorare la diagnosi e la cura delle malattie del sangue rare.
                  </p>

                  <p>
                    L'ERN-EuroBloodNet è organizzata in due macroaree:
                  </p>

                  <div className="grid md:grid-cols-2 gap-6 my-6">
                    <div className="bg-gray-50 p-5 rounded-lg shadow-sm border border-gray-200">
                      <h3 className="text-xl font-semibold mb-3 text-primary">Malattie ematologiche rare oncologiche</h3>
                      <ul className="list-disc pl-5 space-y-1">
                        <li>Neoplasie mieloidi</li>
                        <li>Neoplasie linfoidi</li>
                      </ul>
                    </div>

                    <div className="bg-gray-50 p-5 rounded-lg shadow-sm border border-gray-200">
                      <h3 className="text-xl font-semibold mb-3 text-primary">Malattie ematologiche rare non oncologiche</h3>
                      <ul className="list-disc pl-5 space-y-1">
                        <li>Malattie rare dei globuli rossi</li>
                        <li>Insufficienze midollari e disordini dell'emopoiesi</li>
                        <li>Malattie rare della coagulazione</li>
                        <li>Emocromatosi e altri disordini genetici rari del metabolismo del ferro e della sintesi dell'eme</li>
                      </ul>
                    </div>
                  </div>

                  <p>
                    Per promuovere l'eccellenza, per garantire la miglior assistenza sanitaria e la miglior qualità della vita possibile per i cittadini europei affetti da malattia ematologica rara, nell'ambito dell'ERN-EuroBloodNet sono stati identificati cinque campi trasversali su cui agire, ciascuno dei quali con un obiettivo:
                  </p>

                  <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 my-6">
                    <div className="p-4 bg-gray-50 rounded-lg shadow-sm border-l-4 border-primary">
                      <h4 className="font-semibold text-gray-800 mb-2">Sanità transfrontaliera</h4>
                      <p className="text-sm text-gray-700">Istituire un sistema di riferimento clinico e di laboratorio al fine di garantire equità nella possibilità di accesso all'assistenza sanitaria in tutta Europa.</p>
                    </div>

                    <div className="p-4 bg-gray-50 rounded-lg shadow-sm border-l-4 border-primary">
                      <h4 className="font-semibold text-gray-800 mb-2">Pratiche Cliniche Ottimali</h4>
                      <p className="text-sm text-gray-700">Promuovere la raccolta, aggiornamento, creazione e diffusione delle migliori pratiche cliniche.</p>
                    </div>

                    <div className="p-4 bg-gray-50 rounded-lg shadow-sm border-l-4 border-primary">
                      <h4 className="font-semibold text-gray-800 mb-2">Formazione Medica Continua</h4>
                      <p className="text-sm text-gray-700">Diffondere conoscenze all'avanguardia attraverso un programma educazionale diretto dai massimi esperti dei vari settori, sia mediante la formazione sul campo sia online.</p>
                    </div>

                    <div className="p-4 bg-gray-50 rounded-lg shadow-sm border-l-4 border-primary">
                      <h4 className="font-semibold text-gray-800 mb-2">Telemedicina</h4>
                      <p className="text-sm text-gray-700">Facilitare la consulenza a distanza tra i massimi esperti del settore di casi complessi di malattia ematologica rara, sia a fini diagnostici sia assistenziali.</p>
                    </div>

                    <div className="p-4 bg-gray-50 rounded-lg shadow-sm border-l-4 border-primary">
                      <h4 className="font-semibold text-gray-800 mb-2">Studi Clinici e Ricerca</h4>
                      <p className="text-sm text-gray-700">Promuovere la cooperazione ai fini della sorveglianza epidemiologica, della partecipazione a sperimentazioni cliniche, dello sviluppo di progetti di ricerca collaborativa e di nuove tecnologie.</p>
                    </div>
                  </div>

                  <div className="mt-6 p-4 bg-accent/5 rounded-lg border border-accent/10">
                    <p className="text-accent/80">
                      <span className="font-semibold">Nota:</span> Purtroppo, ci sono delle malattie rare "senza nome", non ancora identificate, che sono delle condizioni, caratterizzate da disturbi e disabilità. Per approfondire l'argomento, consultare il{" "}
                      <a href="https://www.malattierare.gov.it/malattie/malattieSenzaDiagnosi" target="_blank" rel="noopener noreferrer" className="text-accent hover:text-accent/90 font-semibold hover:underline transition-colors duration-200">
                        sito del Ministero della Salute – Istituto Superiore di Sanità
                      </a>
                    </p>
                  </div>

                  <div className="mt-8 text-right italic text-gray-600">
                    A cura della Dott.ssa Fiorina Giona
                  </div>
                </div>
              )}

              {openSectionModal === 'eventi' && (
                <div className="space-y-6 text-gray-700">
                  <p className="text-sm text-gray-500">
                    In questa sezione sono raccolti gli eventi istituzionali dedicati alle malattie rare.
                  </p>
                  <article className="border border-gray-200 rounded-lg overflow-hidden">
                    <div className="flex flex-col md:flex-row gap-6 p-5 bg-gray-50 border-b border-gray-200">
                      <img
                        src={summitMalattieRareEvent.poster}
                        alt={`Locandina ${summitMalattieRareEvent.title}`}
                        className="w-full md:w-56 h-auto object-contain rounded-md shadow-sm mx-auto md:mx-0 flex-shrink-0"
                      />
                      <div className="flex flex-col justify-center">
                        <h3 className="text-2xl font-bold text-blue-800 mb-3">{summitMalattieRareEvent.title}</h3>
                        <p className="flex items-center text-gray-700 mb-1">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-700 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" focusable="false">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          {summitMalattieRareEvent.date}
                        </p>
                        <p className="flex items-center text-gray-700 mb-2">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2 text-blue-700 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" focusable="false">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          {summitMalattieRareEvent.location}
                        </p>
                        <p className="text-sm text-gray-600 mb-3">
                          {summitMalattieRareEvent.organizers}
                        </p>
                        <p className="text-gray-700">{summitMalattieRareEvent.intro}</p>
                      </div>
                    </div>
                    <div className="p-5">
                      <div
                        className="max-w-none text-gray-700"
                        dangerouslySetInnerHTML={{ __html: summitMalattieRareEvent.reportHtml }}
                      />
                      <div className="mt-6 pt-5 border-t border-gray-200">
                        <h4 className="font-semibold text-gray-800 mb-3">Documenti dell'evento</h4>
                        <div className="flex flex-col sm:flex-row flex-wrap gap-3">
                          {summitMalattieRareEvent.documents.map((doc) => (
                            <a
                              key={doc.label}
                              href={doc.file}
                              download={doc.downloadName}
                              className="inline-flex items-center px-4 py-2 bg-accent text-white text-sm font-medium rounded-md hover:bg-accent/90 transition-colors duration-200"
                              aria-label={`Scarica ${doc.label}`}
                            >
                              <svg xmlns="http://www.w3.org/2000/svg" className="mr-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} aria-hidden="true" focusable="false">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                              </svg>
                              Scarica {doc.label}
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              )}
            </div>
            <div className="p-4 bg-gray-50 border-t flex justify-end">
              <button
                onClick={() => setOpenSectionModal(null)}
                className={`px-4 py-2 ${openSectionModal === 'eventi' ? 'bg-blue-700 hover:bg-blue-800' : 'bg-accent hover:bg-accent/90'} text-white font-medium rounded-lg transition-colors duration-200`}
              >
                Chiudi
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Home Link */}
      {/* <div className="py-8 text-center">
        <Link to="/" className="text-accent hover:text-accent/90 hover:underline transition-colors duration-200">
          Torna alla Home
        </Link>
      </div> */}
    </div>
  );
};

export default MalattieRare;
